import { REFERRAL_WINNING_PERCENTANGE } from '@/constants/static';

export const langModalData = [
  {
    code: 'ENGLISH',
    suffix: 'en',
    name: 'English',
    title: 'Choose Your Language',
    description:
      'Language settings can be changed as per preference in Profile',
    cta: 'Continue',
  },
  {
    code: 'HINDI',
    suffix: 'हिं',
    name: 'हिंदी',
    title: 'अपनी भाषा चुनें',
    description:
      'प्रोफ़ाइल में प्राथमिकता के अनुसार भाषा सेटिंग्स को बदला जा सकता है',
    cta: 'जारी रखें',
  },
  {
    code: 'GUJARATI',
    suffix: 'ગુ',
    name: 'ગુજરાતી',
    title: 'તમારી ભાષા પસંદ કરો',
    description: 'પ્રોફાઇલમાં પસંદગી મુજબ ભાષા સેટિંગ્સ બદલી શકાય છે',
    cta: 'ચાલુ રાખો',
  },
  {
    code: 'MARATHI',
    suffix: 'मर',
    name: 'मराठी',
    title: 'तुमची भाषा निवडा',
    description: 'प्रोफाईलमधील प्राधान्यानुसार भाषा सेटिंग्ज बदलता येतात',
    cta: 'सुरू',
  },
  {
    code: 'BAHASA_INDONESIA',
    suffix: 'id',
    name: 'Bahasa',
    title: 'Pilih Bahasa Anda',
    description:
      'Pengaturan bahasa dapat diubah sesuai dengan preferensi di Profil',
    cta: 'Lanjutkan',
  },
];

export const LANGUAGES_CONTENT = {
  ENGLISH: {
    login: {
      title: 'Welcome to CashPlay',
      cta: 'Login with Google',
      phoneLogin: {
        title: 'Login with Phone Number',
        enterPhone: 'Enter Phone Number',
        phoneDescription: 'Please enter your phone number to receive an OTP.',
        getOtp: 'Get OTP',
        enterOtp: 'Enter OTP',
        otpDescription: 'Please enter the OTP sent to your phone.',
        submit: 'Submit',
        retryOtp: 'Retry OTP in {timer} seconds',
        resendOtp: 'Resend OTP',
      },
    },
    signup: {
      referralLabel: 'Redeem Code',
      referralPlaceholder: 'Enter the Referral Code',
      nameLabel: 'Your Name',
      namePlaceholder: 'Enter you Full Name',
      submit: 'Submit',
      skip: 'Skip',
    },
    home: {
      notification: {
        title: 'Enable notification permission',
        description:
          'Enable notifications to get instant updates on your earning journey.',
        btn: 'Enable',
      },
      sdk: {
        play: 'Play & Earn',
        survey: 'Survey Rewards',
        spin: 'Spin & Win',
        games: 'Games',
      },
      filters: {
        title: 'Filter',
        selected: 'selected',
        type: 'Offer Type',
        category: 'Offer Category',
        applyAction: 'Apply',
        clearAll: 'Clear all',
      },
      tags: {
        SINGLE_STEP: 'Single-Step',
        MULTI_REWARD: 'Multi-Reward',
        GAMING: 'Gaming',
        FINANCE: 'Finance',
        SURVEY: 'Survey',
        DEPOSIT: 'Need Deposit',
        NEW: 'New',
      },
      sort: {
        title: 'Sort',
        default: 'Default (Relevance)',
        ttfp: 'Time',
        price: 'Reward',
        highToLow: 'High to Low',
        lowToHigh: 'Low to High',
      },
    },
    nav: {
      wallet: 'Wallet Balance',
      home: 'Home',
      offers: 'Offers',
      refer: 'Refer',
      contest: 'Contest',
      settings: 'Settings',
      back: 'Back',
      logout: 'Logout',
      logoutmodal: 'Are you sure you want to logout',
    },
    dailycheckin: {
      notclaimed: {
        header: {
          title: 'Congrats',
          description: 'Come everyday to earn amazing rewards.',
        },
        footer: {
          description:
            'Your reward is ready to be claimed. Click the button below to claim your reward.',
          cta: 'Claim',
          offercta: 'Complete One Offer to Claim',
        },
      },
      claiming: {
        congrats: 'Congratulations!',
        reward: 'You got an reward',
        success: 'You have successfully claimed',
      },
      claimed: {
        reward: 'Your Rewards',
        nextreward: 'Your next reward in',
        day: 'Day',
      },
    },
    settings: {
      title: 'Settings',
      profile: 'Profile',
      help: 'Help',
      tc: 'T&C',
      privacy: 'Privacy',
      contact: 'Contact Us',
      language: 'Language',
      description: 'Please use the button below to contact us via email',
    },
    offers: {
      allOfferHome: 'All Offers',
      all: 'All',
      ongoing: 'Ongoing',
      availed: 'Availed',
      expired: 'Expired',
      supporthead: 'Support',
      avgTime: 'Avg. Reward Time',
      comment: {
        error: 'Please enter atleast 30 characters',
        submitBtn: 'Submit',
        inputLabel: 'Feedback',
        feedback: 'Thank you for your feedback',
      },
      voteErrors: {
        5001: 'Cannot vote before the offer has started',
        5002: 'Maximum number of votes have been utilized',
        5003: 'Voting time limit has exceeded',
        5005: 'Feedback is mandatory for a down vote',
        5006: 'No of characters in Feedback is out of limit',
      },
      type: {
        CPI: 'Get Now',
        CPA: 'Complete Now',
        CPR: 'Register Now',
        'APK-INSTALL': 'Get Now',
        'APK-REGISTER': 'Register Now',
        CPL: 'Complete Now',
        default: 'Complete Now',
      },
      supportoffercard: {
        title: 'Est. time for reward : 3 days',
        description:
          'Sometimes advertisers take upto 3 days to verify your reward.',
      },
      nooffer: {
        title: 'Sorry, we couldn’t find the offer you’re looking for.',
        cta: 'Explore More Offers',
        ongoing: 'No ongoing offers',
        completed: 'No completed offers',
        nooffer: 'No offers',
      },
      offerNotAvailable: {
        title:
          'We apologize, but this offer is currently unavailable. Please explore our other offers.',
        cta: 'Explore More Offers',
      },
      termscondition:
        'By taking part in any offer or event, you agree to the subsequent terms and conditions. Should a reward not be granted for achieving the specified goal due to circumstances not attributable to us, further rewards will be forfeited. Kindly note that eligibility for rewards necessitates the creation of a new account; pre-existing accounts are ineligible for this particular reward. Rewards will exclusively be conferred upon the completion of levels explicitly outlined in the offer for the designated application. Moreover, this multi-reward offer cannot be combined with concurrent offers pertaining to the same application. To access multiple rewards for accomplishing the designated levels, please click the button below and initiate the application. It is important to be aware that these terms and conditions universally apply to all offers and events; however, specific details may vary according to individual promotions. It is advisable to review the pertinent terms for each offer before participating.',
      disclaimer: {
        title: 'Disclaimer',
        points: [
          'The App should not have been installed on your device in the last 30 days.',
          'Reward will be given post completion of all the steps.',
          'Reward will only be given post confirmation from the advertiser. ',
          'Advertisers might take upto 24 hours to confirm the reward.',
          'Any fraud activity, including the use of VPN,will result in ban of account.',
        ],
      },
      details: {
        steps: 'Steps for completion',
        support: 'Facing issues?',
        reach: 'Reach out to us',
        terms: 'Terms & Conditions',
        read: 'Read more',
        btnactions: {
          open: 'Open App',
          get: 'Get',
        },
        status: {
          chips: {
            expired: 'Expired',
            useapp: 'Waiting to Use App',
            waiting: 'Waiting',
            ongoing: 'Ongoing',
            unlock: 'Waiting to Unlock',
            completed: 'Completed',
          },
          expired: {
            title: 'This offer has expired !',
            description:
              'Looks like this offer is no longer available. Explore more offers to get your next reward!',
          },
          cpl: {
            title: 'Time to complete',
          },
          ongoing: {
            title: 'Your reward is on its way!',
            description:
              'Sometimes advertisers take upto 3 days to confirm your action. Check out other offers for more rewards!',
          },
          retention: {
            unlock: 'Time to Unlock Daily Reward',
            ongoing: 'Open and Explore the App!',
            description:
              'The more you use the app, the greater the assurance of receiving rewards.',
          },
          completed: {
            title: 'Congrats!',
            description:
              'Rewarded for completing this offer. Explore more offers to get your next reward!',
          },
        },
      },
      support: [
        {
          question: 'Incorrect reward value received',
          answer:
            'You can raise a support query for the above offer. Please let us know if there is an issue with the offers you have initiated',
          action: 'Contact us',
        },
        {
          question: 'Did not receive reward for the offer',
          answer:
            'You can raise a support query for the above offer. Please let us know if there is an issue with the offers you have initiated',
          action: 'Contact us',
        },
        {
          question:
            'I have completed all the steps mentioned in the offer, but my offer is still ongoing. What do I do now?',
          answer: (
            <>
              <ul className="pl-4 mt-1 list-disc">
                <li>
                  The offer will also be shown in ongoing offers while we are
                  verifying your completion.
                </li>
                <li>
                  Please ensure that you have utilized the app for a minimum of
                  5 minutes to qualify for the reward.
                </li>
              </ul>
            </>
          ),
        },
      ],
    },
    help: {
      title: 'Frequently asked questions',
      header: {
        title: (
          <>
            Tell us about <br className="portrait:hidden" /> Issues that you are
            facing
          </>
        ),
        description: 'Ideal time for reply is less than 24 hours',
      },
      support: {
        title: 'Facing issue? Talk to us',
        cta: 'Contact Us',
      },
      items: [
        {
          question: 'How can I avail an offer?',
          answer: (
            <>
              Follow these steps to avail an offer:
              <ul className="pl-4 mt-1 list-disc">
                <li>Click on the offer to view the offer details.</li>
                <li>
                  Read all the steps carefully and perform all the steps one by
                  one.
                </li>
                <li>
                  The rewards will be given once we have verified that the tasks
                  are completed.
                </li>
              </ul>
            </>
          ),
        },
        {
          question: 'When will I receive the rewards?',
          answer:
            'You will receive rewards once we verify that you have completed all the steps mentioned in the offer.',
        },
        {
          question: 'What is an ongoing offer?',
          answer:
            'An ongoing offer is one you have completed partially, i.e., where you have not completed all the steps or we are in the process of verifying your completion.',
        },
        {
          question:
            'I have completed all the steps mentioned in the offer, but my offer is still ongoing. What do I do now?',
          answer: (
            <>
              <ul className="pl-4 mt-1 list-disc">
                <li>
                  The offer will also be shown in ongoing offers while we are
                  verifying your completion.
                </li>
                <li>
                  Please ensure that you have utilized the app for a minimum of
                  5 minutes to qualify for the reward.
                </li>
              </ul>
            </>
          ),
        },
        {
          question: 'How do I receive the rewards?',
          answer:
            'The rewards will automatically be added to your wallet on the successful completion of the offer.',
        },
      ],
    },
    refer: {
      title: 'Refer & Earn',
      redirect: 'Redirecting...',
      view: 'View Referrals',
      refercta: 'Refer a friend now',
      share: 'Refer code',
      howto: {
        title: 'How it Works',
        items: [
          {
            title: 'Invite your friends',
            description: 'Just share your link',
          },
          {
            title: 'They hit the road',
            description: 'When your friend complete 3 offers',
          },
          {
            title: `You earn ${REFERRAL_WINNING_PERCENTANGE}% of what they earn on 3 offers`,
            description: 'Your friend earns 5% extra on first 3 offers',
          },
          {
            title: 'You can refer a lot of friends',
            description: 'Sit back and relax, while your wallet is filled',
          },
        ],
      },
      list: {
        title: 'Your Referrals',
        description:
          'Your referrals should complete a set of milestones for you to receive referral coins.',
        offerscompleted: 'Offers Completed',
      },
    },
    contest: {
      tabs: {
        ongoing: 'Ongoing',
        older: 'Older',
        stats: 'Your Stats',
        leaderboard: 'Leaderboard',
        rules: 'Rules',
      },
      leaderboard: {
        loading: 'Loading...',
        rank: 'Your Rank',
        prize: 'Prize',
        update: 'Last Updated At:',
        offertype: {
          offer: 'Offers',
          refer: 'Referrals',
        },
      },
      modal: {
        joined: 'Contest Joined',
        offertype: {
          offer: (
            <>
              Start Winning,
              <br />
              Complete Offers
            </>
          ),
          refer: (
            <>
              Start Winning,
              <br />
              Start Referring
            </>
          ),
        },
        cta: 'Start Earning',
      },
      status: {
        title: 'Contest',
        close: 'Closed',
        ends: 'Ends in',
        starts: 'Starts in',
        headers: {
          completed: 'This contest is over.',
          refer: 'Earn rewards for referring friends.',
          offer: 'Earn rewards for completing maximum offers.',
        },
      },
      freejoin: 'Join now for Free',
      rankcard: {
        rank: 'Your Rank',
        reward: 'Your Reward',
        top: 'Keep doing offers to stay in top',
        climb: 'Keep doing offers to climb up the leaderboard',
        cta: 'Go to Offers',
      },
      refercard: {
        title: 'Refer and earn via',
        invite: 'Invite via Referral Code',
        top: 'Keep doing offers to stay in top',
        climb: 'Keep doing offers to climb up the leaderboard',
        copy: 'Copy',
      },
      contestcard: {
        register: 'Registered',
        join: {
          profilejoined:
            'You have joined the contest, Start earning by doing tasks!',
          joined: 'Contest Joined',
          cta: 'Join now',
        },
        rank: 'Your Rank',
        reward: 'Your Reward',
        entry: 'Entry',
        free: 'FREE',
        maxreward: 'Max Reward',
        details: 'View Details',
      },
      rewardcard: {
        title: 'Contest Rewards',
        rank: 'Ranks',
        reward: 'Rewards',
      },
      errorboundary: {
        header: {
          title: 'Oops!',
          description: 'Something went wrong.',
        },
        description:
          'We are sorry for the inconvenience. close and reopen the app to try again. If the problem persists, please report the issue.',
        feedbackcta: 'Report feedback',
        retrycta: 'Retry',
      },
      join: 'Join now for',
      freejoin: 'Free',
      minimumBalance: ({ value, currency }) => (
        <>
          You must have {value} {currency} to join
        </>
      ),
    },
    profile: {
      title: 'Profile',
      earning: 'Earning since',
      stats: {
        title: 'Statistics',
        totalearned: 'Coins Earned',
        redeem: 'Redeemed Amount',
        offers: 'Offers Tried',
        refer: 'Referrals',
      },
    },
    wallet: {
      title: 'Wallet balance',
      redeem: 'Redeem Now',
      earning: 'Earning History',
      transaction: 'Transaction History',
    },
    redeem: {
      store: {
        title: 'Redeem Store',
        maxredemption:
          'The maximum number of redemptions allowed has been reached.',
        noredeemoption: (
          <>
            <p>No Redeem Options are currently available</p>
            <p>Please try again later or contact our support team.</p>
          </>
        ),
      },
      pack: {
        nodata: 'You will see packs here once they are available.',
      },
      payout: {
        form: {
          title: 'Redeem',
          placeholder: 'Enter your payment address',
          noemail:
            'This pack requires an email address to be set in your profile.',
          cta: 'Proceed',
          confirmdialog: {
            title: 'Are you sure?',
            address: 'Payment Address:',
            amount: 'Amount:',
            confirm: 'Confirm',
            cancel: 'Cancel',
          },
        },
        status: {
          note: 'Note:',
          reason: 'Reason:',
          rateus: 'Rate us on Play Store',
          processing: {
            title: 'Payment Processing',
            description:
              'The payment is generally credited to your account within 6 hours. Until then, your coins are safe with us.',
          },
          processed: 'Payment Successful',
          failed: 'Payment Failed',
          stillprocess: {
            title: 'Payment is still processing',
            description:
              'A payment request has been sent. Refunds will be issued to the wallet in case of failure.',
          },
        },
        crypto: {
          download: {
            title: "Don't have a Lightning Address?",
            cta: 'Download ZBD here!',
          },
          info: {
            title: 'How to find the lightning address in ZBD app?',
            steps: [
              {
                title: 'Install ZBD app from playstore',
                cta: 'Install ZBD',
              },
              {
                title: 'Click on side menu profile icon',
              },
              {
                title: 'Click on the username',
                description:
                  'This will copy the lightning address to your clipboard',
              },
            ],
          },
        },
      },
    },
    spin: {
      title: 'Spin & Win',
      description:
        'Stand a chance to win a bag full of Gems for spinning the wheel of fortune.',
      timer: {
        wait: 'Wait for',
        end: 'to test your fortune.',
      },
      cta: 'Spin',
      completeoffer: {
        cta: 'Complete One task to unlock',
        description: 'You have to complete one offer to unlock spin!',
      },
      modal: {
        oops: 'Oops!',
        better: 'Better luck next time',
        congrats: 'Congratulations!',
        won: 'you have won',
      },
      again: {
        title: 'Come back again to win more',
        cta: 'Explore other tasks',
      },
    },
    empty: {
      available: 'No data available',
      data: 'No data',
      found: 'No data found',
      referrals: 'No refrrals yet',
      contest: {
        ongoing: 'No ongoing contests',
        old: 'No older contests',
      },
      offers: {
        ongoing: 'No ongoing offers',
        completed: 'No completed offers',
        found: 'No offers found',
        resetFilterCta: 'Reset Filters',
      },
      internet: 'No active internet connection!',
    },
    toast: {
      refer: {
        copy: 'Referral code copied',
        emptycode: 'Please enter referral code',
        notExist: 'Referral does not exist',
      },
      failed: 'Failed to share, Please try again',
      redeem: {
        maxredemption:
          'The maximum number of redemptions allowed has been reached. Please try again later.',
        pack: 'This pack is not available at the moment',
        validaddress: 'Please enter a valid payment address',
        invalid: 'Invalid Email ID',
      },
      loginfailed: 'Google login failed',
    },
    dialog: {
      offline: {
        title: 'Oops, No Internet Connection',
        description:
          'Please turn on your WiFi or mobile data to access the available offers.',
      },
      error: {
        title: 'Something went wrong',
        description:
          'This is not you, this is us! <br /> Don’t worry, try again',

        cta: 'Retry',
      },
      notfound: {
        title: '404 | Page Not Found',
        description: 'The page you are looking for is not found.',
        cta: 'Explore Offers',
      },
      enableUsagePermission: {
        title: 'Enable Usage Access',
        description:
          'Enable usage access to get amazing rewards from this offer now!',
        cta: 'Enable',
      },
      confirmAlert: {
        cta: {
          confirm: 'Confirm',
          cancel: 'cancel',
        },
      },
      banned: {
        heading: 'You are banned from using CashPlay.',
        description:
          'If you think this is a mistake, please contact support at',
      },
      editProfile: {
        name: 'Name',
      },
      fraud: {
        vpn: {
          title: 'Oops, We have Detected an VPN',
          desc: `To ensure you have a smooth and secure experience, you have to turn
      off VPN.`,
        },
        rooted: {
          title: 'Oops, We have Detected a rooted device',
          desc: `To ensure you have a smooth and secure experience, you have to use a non rooted device`,
        },
        modApp: {
          title: 'Oops, We have Detected you are using mod App',
          desc: `To ensure you have a smooth and secure experience, you have to download correct app`,
        },
        developerOptions: {
          title: 'Oops, We have detected that developer options are turned on',
          desc: `To ensure you have a smooth and secure experience, you have to turn
        off Developer Options.`,
        },
        emulator: {
          title: 'Oops, We have detected an emulator',
          desc: `To ensure you have a smooth and secure experience, please use it in normal app.`,
        },
        blacklistedApp: fraud => ({
          title: 'Alert! Suspicious App Detected',
          desc: (
            <div>
              <p className="mb-4">
                {`Please uninstall the apps listed below to use the app`}
              </p>
              {fraud?.data?.map((d, index) => (
                <p key={index} className="my-1 text-color text-md ">
                  {d}
                </p>
              ))}
            </div>
          ),
        }),
        clone: {
          title: 'Oops, We have detected that your device is cloned',
          desc: `To ensure you have a smooth and secure experience, you have to use a non cloned device`,
        },
      },
    },
    forceUpdate: {
      title: `Hey! We've just released a new app update with great features, improvements, and bug fixes. Please install it now for the best experience. Enjoy!`,
      cta: 'Update App',
    },
  },
  HINDI: {
    login: {
      title: 'CashPlay में आपका स्वागत है',
      cta: 'गूगल से लॉगिन करें',
      phoneLogin: {
        title: 'फोन नंबर से लॉगिन करें',
        enterPhone: 'फोन नंबर दर्ज करें',
        phoneDescription:
          'OTP प्राप्त करने के लिए कृपया अपना फोन नंबर दर्ज करें।',
        getOtp: 'OTP प्राप्त करें',
        enterOtp: 'OTP दर्ज करें',
        otpDescription: 'कृपया अपने फोन पर भेजा गया OTP दर्ज करें।',
        submit: 'जमा करें',
        retryOtp: '{timer} सेकंड में OTP फिर से प्रयास करें',
        resendOtp: 'OTP फिर से भेजें',
      },
    },
    signup: {
      referralLabel: 'रीडीम कोड',
      referralPlaceholder: 'रेफरल कोड दर्ज करें',
      nameLabel: 'आपका नाम',
      namePlaceholder: 'अपना पूरा नाम दर्ज करें',
      submit: 'जमा करना',
      skip: 'छोड़ें',
    },
    home: {
      notification: {
        title: 'अधिसूचना अनुमति सक्षम करें',
        description:
          'अपनी कमाई की यात्रा पर तुरंत अपडेट प्राप्त करने के लिए सूचनाएं सक्षम करें।',
        btn: 'सक्षम',
      },
      sdk: {
        play: 'खेलें और कमाएं',
        survey: 'सर्वेक्षण इनाम',
        spin: 'घुमाएँ और जीतें',
        games: 'गेम्स',
      },
      filters: {
        title: 'फ़िल्टर',
        selected: 'चयनित',
        type: 'ऑफ़र प्रकार',
        category: 'ऑफ़र श्रेणी',
        applyAction: 'लागू करें',
        clearAll: 'सभी साफ़ करें',
      },
      tags: {
        SINGLE_STEP: 'एकल-कार्य',
        MULTI_REWARD: 'मल्टी-इनाम',
        GAMING: 'गेमिंग',
        FINANCE: 'वित्त',
        SURVEY: 'सर्वेक्षण',
        DEPOSIT: 'जमा की आवश्यकता',
        NEW: 'नया',
      },
      sort: {
        title: 'सॉर्ट',
        default: 'डिफ़ॉल्ट (प्रासंगिकता)',
        ttfp: 'समय',
        price: 'इनाम',
        highToLow: 'ऊँचे से नीचे',
        lowToHigh: 'नीचे से ऊँचे',
      },
    },
    nav: {
      wallet: 'वॉलेट बैलेंस',
      home: 'होम',
      offers: 'ऑफर',
      refer: 'रेफ़र',
      contest: 'प्रतियोगिता',
      settings: 'समायोजन',
      back: 'वापस',
      logout: 'लॉगआउट',
      logoutmodal: 'क्या आप वाकई लॉगआउट करना चाहते हैं?',
    },
    dailycheckin: {
      notclaimed: {
        header: {
          title: 'बधाई हो',
          description: 'हर दिन आकर्षक इनाम कमाने के लिए हर दिन आइए।',
        },
        footer: {
          description:
            'आपका इनाम प्राप्त करने के लिए तैयार है। अपना इनाम प्राप्त करने के लिए नीचे दिए गए बटन पर क्लिक करें।',
          cta: 'दावा करें',
          offercta: 'दावा करने के लिए एक प्रस्ताव पूरा करें',
        },
      },
      claiming: {
        congrats: 'बधाई हो!',
        reward: 'आपने एक इनाम प्राप्त किया है',
        success: 'आपने सफलतापूर्वक दावा किया है',
      },
      claimed: {
        reward: 'आपके इनाम',
        nextreward: 'आपका अगला इनाम',
        day: 'दिन',
      },
    },
    settings: {
      title: 'सेटिंग्स',
      profile: 'प्रोफ़ाइल',
      help: 'सहायता',
      tc: 'टीसी',
      privacy: 'प्राइवेसी',
      contact: 'संपर्क करें',
      language: 'भाषा',
      description:
        'कृपया ईमेल के माध्यम से हमसे संपर्क करने के लिए नीचे दिए गए बटन का उपयोग करें',
    },
    offers: {
      allOfferHome: 'ऑफ़र',
      all: 'सभी ऑफर',
      ongoing: 'जारी है',
      availed: 'लाभान्वित',
      expired: 'समाप्त',
      supporthead: 'सहायता',
      avgTime: 'औसत इनाम समय',
      comment: {
        error: 'कृपया कम से कम 30 अक्षर दर्ज करें',
        submitBtn: 'प्रस्तुत करे',
        inputLabel: 'प्रतिक्रिया',
        feedback: 'आपकी प्रतिक्रिया के लिए धन्यवाद',
      },
      voteErrors: {
        5001: 'ऑफ़र शुरू होने से पहले वोट नहीं कर सकते',
        5002: 'अधिकतम वोटों की संख्या पूरी हो गई है',
        5003: 'वोटिंग समय सीमा समाप्त हो गई है',
        5005: 'डाउन वोट के लिए प्रतिक्रिया अनिवार्य है',
        5006: 'प्रतिक्रिया में वर्णों की संख्या सीमा से बाहर है',
      },
      type: {
        CPI: 'अभी प्राप्त करें',
        CPA: 'अभी पूरा करें',
        CPR: 'अभी पंजीकरण करें',
        'APK-INSTALL': 'अब प्राप्त करें',
        'APK-REGISTER': 'अभी पंजीकरण करें',
        CPL: 'अभी पूरा करें',
        default: 'अभी पूरा करें',
      },
      supportoffercard: {
        title: 'पुरस्कार के लिए अनुमानित समय: 3 दिन',
        description:
          'कभी-कभी विज्ञापकों को आपके पुरस्कार की पुष्टि करने में तीन दिन लग सकते हैं।',
      },
      nooffer: {
        title: 'क्षमा करें, हमें वह ऑफ़र नहीं मिल सका जिसकी आप तलाश कर रहे थे।',
        cta: 'अधिक ऑफ़र खोजें',
        ongoing: 'कोई चालू ऑफर नहीं',
        completed: 'कोई पूर्ण ऑफर नहीं',
        nooffer: 'कोई ऑफर नहीं',
      },
      offerNotAvailable: {
        title:
          'हमें खेद है, लेकिन यह ऑफर वर्तमान में उपलब्ध नहीं है। कृपया हमारे अन्य ऑफ़र देखें।',
        cta: 'और ऑफ़र देखें',
      },
      termscondition:
        'किसी भी ऑफर या इवेंट में हिस्सा लेकर आप उसके बाद के नियमों और शर्तों से सहमत होते हैं। यदि निर्दिष्ट लक्ष्य को प्राप्त करने के लिए उन परिस्थितियों के कारण पुरस्कार नहीं दिया जाता है जो हमारे लिए जिम्मेदार नहीं हैं, तो आगे के पुरस्कार जब्त कर लिए जाएंगे। कृपया ध्यान दें कि पुरस्कारों की पात्रता के लिए एक नया खाता बनाना आवश्यक है; पहले से मौजूद खाते इस विशेष पुरस्कार के लिए पात्र नहीं हैं। निर्दिष्ट आवेदन के लिए प्रस्ताव में स्पष्ट रूप से उल्लिखित स्तरों को पूरा करने पर पुरस्कार विशेष रूप से प्रदान किए जाएंगे। इसके अलावा, इस बहु-इनाम ऑफर को एक ही एप्लिकेशन से संबंधित समवर्ती ऑफर के साथ नहीं जोड़ा जा सकता है। निर्दिष्ट स्तरों को पूरा करने के लिए कई पुरस्कारों तक पहुंचने के लिए, कृपया नीचे दिए गए बटन पर क्लिक करें और आवेदन शुरू करें। यह जानना महत्वपूर्ण है कि ये नियम और शर्तें सार्वभौमिक रूप से सभी प्रस्तावों और आयोजनों पर लागू होती हैं; हालाँकि, विशिष्ट विवरण अलग-अलग प्रचारों के अनुसार भिन्न हो सकते हैं। भाग लेने से पहले प्रत्येक ऑफ़र के लिए प्रासंगिक शर्तों की समीक्षा करना उचित है।',

      disclaimer: {
        title: 'अस्वीकरण',
        points: [
          'एप को आपके डिवाइस पर पिछले 30 दिनों में इंस्टॉल नहीं किया गया होना चाहिए।',
          'रिवॉर्ड सभी स्टेप्स को पूरा करने के बाद दिया जाएगा।',
          'रिवॉर्ड केवल विज्ञापनदाता से पुष्टि मिलने के बाद ही दिया जाएगा। ',
          'विज्ञापनदाता रिवॉर्ड की पुष्टि करने में 24 घंटे तक का समय ले सकते हैं।',
          'किसी भी धोखाधड़ी गतिविधि, यहां तक कि वीपीएन का उपयोग भी, के परिणामस्वरूप खाता प्रतिबंधित कर दिया जाएगा।',
        ],
      },
      details: {
        steps: 'निर्देश',
        support: 'मुद्दों का सामना कर रहे हैं?',
        reach: 'हमसे संपर्क करें',
        terms: 'नियम और शर्तें',
        read: 'और पढ़ें',
        btnactions: {
          open: 'ऐप खोलें',
          get: '',
        },
        status: {
          chips: {
            expired: 'समाप्त',
            useapp: 'ऐप के उपयोग की प्रतीक्षा की जा रही है',
            waiting: 'इंतज़ार में',
            ongoing: 'जारी है',
            unlock: 'अनलॉक होने का इंतजार किया जा रहा है',
            completed: 'पूरा कर लिया है',
          },
          expired: {
            title: 'यह ऑफर समाप्त हो गया है!',
            description:
              'ऐसा लगता है कि यह ऑफ़र अब उपलब्ध नहीं है. अपना अगला इनाम पाने के लिए और ऑफ़र खोजें!',
          },
          cpl: {
            title: 'पूरा होने का समय',
          },
          ongoing: {
            title: 'आपका इनाम आने वाला है!',
            description:
              'कभी-कभी विज्ञापनदाताओं को आपकी कार्रवाई की पुष्टि करने में 3 दिन तक का समय लग जाता है। अधिक पुरस्कारों के लिए अन्य ऑफ़र देखें!',
          },
          retention: {
            unlock: 'अगला इनाम अनलॉक करने का समय',
            ongoing: 'ऐप खोलें और एक्सप्लोर करें!',
            description:
              'आप ऐप का जितना अधिक उपयोग करेंगे, इनाम प्राप्त करने का आश्वासन उतना ही अधिक होगा।',
          },
          completed: {
            title: 'बधाई!',
            description:
              'इस ऑफ़र को पूरा करने के लिए पुरस्कृत किया गया. अपना अगला इनाम पाने के लिए और ऑफ़र खोजें!',
          },
        },
      },
      support: [
        {
          question: 'गलत इनाम मूल्य प्राप्त हुआ',
          answer:
            'आप उपरोक्त ऑफर के लिए समर्थन प्रश्न पूछ सकते हैं। कृपया हमें बताएं कि क्या आपके द्वारा शुरू किए गए प्रस्तावों में कोई समस्या है',
          action: 'संपर्क करें',
        },
        {
          question: 'ऑफ़र के लिए इनाम नहीं मिला',
          answer:
            'आप उपरोक्त ऑफर के लिए समर्थन प्रश्न पूछ सकते हैं। कृपया हमें बताएं कि क्या आपके द्वारा शुरू किए गए प्रस्तावों में कोई समस्या है',
          action: 'संपर्क करें',
        },
        {
          question:
            'मैंने ऑफ़र में उल्लिखित सभी चरण पूरे कर लिए हैं, लेकिन मेरा ऑफ़र अभी भी जारी है। अब क्या करूँ?',
          answer: (
            <>
              <ul className="pl-4 mt-1 list-disc">
                <li>
                  जब हम आपके पूरा होने की पुष्टि कर रहे होंगे तो यह ऑफ़र चालू
                  ऑफ़र में भी दिखाया जाएगा।
                </li>
                <li>
                  कृपया सुनिश्चित करें कि आपने इनाम पाने के लिए कम से कम 5 मिनट
                  तक ऐप का उपयोग किया है।
                </li>
              </ul>
            </>
          ),
        },
      ],
    },
    help: {
      title: 'अक्सर पूछे जाने वाले प्रश्नों',
      header: {
        title: (
          <>
            हमें इसके बारे में बताएं <br className="portrait:hidden" /> जिन
            मुद्दों का आप सामना कर रहे हैं
          </>
        ),
        description: 'उत्तर देने का आदर्श समय 24 घंटे से कम है',
      },
      support: {
        title: 'समस्या का सामना करना पड़ रहा है? हमसे बात करें',
        cta: 'संपर्क करें',
      },
      items: [
        {
          question: 'मैं किसी ऑफर का लाभ कैसे उठा सकता हूं?',
          answer: (
            <>
              ऑफ़र का लाभ उठाने के लिए इन चरणों का पालन करें:
              <ul className="pl-4 mt-1 list-disc">
                <li>ऑफ़र विवरण देखने के लिए ऑफ़र पर क्लिक करें।</li>
                <li>
                  सभी चरणों को ध्यान से पढ़ें और एक-एक करके सभी चरण निष्पादित
                  करें।
                </li>
                <li>
                  एक बार जब हम यह सत्यापित कर लेंगे कि कार्य पूरा हो गया है तो
                  इनाम दिए जाएंगे।
                </li>
              </ul>
            </>
          ),
        },
        {
          question: 'मुझे इनाम कब मिलेंगे?',
          answer:
            'एक बार जब हम यह सत्यापित कर लेंगे कि आपने ऑफ़र में उल्लिखित सभी चरण पूरे कर लिए हैं तो आपको इनाम प्राप्त होंगे।',
        },
        {
          question: 'चालू प्रस्ताव क्या है?',
          answer:
            'चालू प्रस्ताव वह है जिसे आपने आंशिक रूप से पूरा किया है, यानी, जहां आपने सभी चरण पूरे नहीं किए हैं या हम आपके पूरा होने की पुष्टि करने की प्रक्रिया में हैं।',
        },
        {
          question:
            'मैंने ऑफ़र में उल्लिखित सभी चरण पूरे कर लिए हैं, लेकिन मेरा ऑफ़र अभी भी जारी है। अब क्या करूँ?',
          answer: (
            <>
              <ul className="pl-4 mt-1 list-disc">
                <li>
                  जब हम आपके पूरा होने की पुष्टि कर रहे होंगे तो यह ऑफ़र चालू
                  ऑफ़र में भी दिखाया जाएगा।
                </li>
                <li>
                  कृपया सुनिश्चित करें कि आपने इनाम पाने के लिए कम से कम 5 मिनट
                  तक ऐप का उपयोग किया है।
                </li>
              </ul>
            </>
          ),
        },
        {
          question: 'मुझे इनाम कैसे प्राप्त होंगे?',
          answer:
            'ऑफ़र के सफल समापन पर इनाम स्वचालित रूप से आपके वॉलेट में जोड़ दिए जाएंगे।',
        },
      ],
    },
    refer: {
      title: 'रेफ़र और कमाओ',
      redirect: 'पुनर्निर्देशन...',
      view: 'रेफ़रल्स देखें',
      refercta: 'अब एक दोस्त को रेफ़र करें',
      share: 'रेफ़र कोड',
      howto: {
        title: 'यह कैसे काम करता है',
        items: [
          {
            title: 'अपने दोस्तों को आमंत्रित करें',
            description: 'बस अपना लिंक साझा करें',
          },
          {
            title: 'शुभारंभ',
            description: 'जब आपका दोस्त 3 प्रस्ताव पूरा करता है',
          },
          {
            title: `आप 3 ऑफ़र पर उनकी कमाई का ${REFERRAL_WINNING_PERCENTANGE}% कमाते हैं`,
            description: 'आपका मित्र पहले 3 ऑफ़र पर 5% अतिरिक्त कमाता है',
          },
          {
            title: 'आप बहुत से दोस्तों को रेफ़र कर सकते हैं',
            description: 'आराम करें और आपकी वॉलेट भरी जाती है',
          },
        ],
      },
      list: {
        title: 'आपके रेफ़रल्स',
        description:
          'आपके रेफ़रल्स को रेफ़रल कॉइन्स प्राप्त करने के लिए एक सेट के मीलस्टोन को पूरा करना चाहिए।',
        offerscompleted: 'ऑफर पूरे हो गए',
      },
    },
    contest: {
      tabs: {
        ongoing: 'जारी है',
        older: 'पुराने',
        stats: 'आपके आँकड़े',
        leaderboard: 'लीडरबोर्ड',
        rules: 'नियम',
      },
      leaderboard: {
        loading: 'लोड हो रहा है...',
        rank: 'आपका रैंक',
        prize: 'इनाम',
        update: 'अंतिम बार अद्यतन किया गया:',
        offertype: {
          offer: 'ऑफर',
          refer: 'रेफरल',
        },
      },
      modal: {
        joined: 'प्रतियोगिता में शामिल हुए',
        offertype: {
          offer: (
            <>
              जीतना शुरू करो,
              <br />
              संपूर्ण ऑफर
            </>
          ),
          refer: (
            <>
              जीतना शुरू करो,
              <br />
              रेफर करना शुरू करें
            </>
          ),
        },
        cta: 'कमाई शुरू करें',
      },
      status: {
        title: 'प्रतियोगिता',
        close: 'बन्द है',
        ends: 'में समाप्त',
        starts: 'में शुरू होता है',
        headers: {
          completed: 'यह प्रतियोगिता ख़त्म हो गई है.',
          refer: 'मित्रों को रेफ़र करने के लिए पुरस्कार अर्जित करें।',
          offer: 'अधिकतम ऑफ़र पूरा करने पर पुरस्कार अर्जित करें।',
        },
      },
      join: 'अभी जुड़ें',
      freejoin: 'मुफ़्त',
      minimumBalance: ({ value, currency }) => (
        <>
          आपके पास {value} {currency} होना चाहिए जुड़ने के लिए
        </>
      ),
      insufficientBalance: 'अपर्याप्त शेष राशि',
      rankcard: {
        rank: 'आपका रैंक',
        reward: 'तुमहारा इनाम',
        top: 'शीर्ष पर बने रहने के लिए ऑफ़र पूरे करते रहें',
        climb: 'लीडरबोर्ड पर ऊपर चढ़ने के लिए ऑफ़र पूरे करते रहें',
        cta: 'ऑफर पर जाएं',
      },
      refercard: {
        title: 'देखें और इसके माध्यम से कमाएँ',
        invite: 'रेफरल कोड के माध्यम से आमंत्रित करें',
        copy: 'कॉपी करें',
      },
      contestcard: {
        register: 'दर्ज कराई',
        join: {
          profilejoined:
            'आप प्रतियोगिता में शामिल हो गए हैं, कार्य करके कमाई करना शुरू करें!',
          joined: 'प्रतियोगिता में शामिल हो गए',
          cta: 'अभी जुड़ें',
        },
        rank: 'आपकी रैंक',
        reward: 'आपका ईनाम',
        entry: 'प्रवेश',
        free: 'मुफ़्त',
        maxreward: 'अधिकतम इनाम',
        details: 'विवरण देखें',
      },
      rewardcard: {
        title: 'प्रतियोगिता के इनाम',
        rank: 'रैंकों',
        reward: 'इनाम',
      },
      errorboundary: {
        header: {
          title: 'उफ़!',
          description: 'कुछ गलत हो गया।',
        },
        description:
          'असुविधा के लिए हमें खेद है। दोबारा प्रयास करने के लिए ऐप को बंद करें और दोबारा खोलें। यदि समस्या बनी रहती है, तो कृपया समस्या की रिपोर्ट करें।',
        feedbackcta: 'प्रतिक्रिया रिपोर्ट करें',
        retrycta: 'पुन: प्रयास करें',
      },
    },
    profile: {
      title: 'प्रोफ़ाइल',
      earning: 'कमाई कब से',
      stats: {
        title: 'आंकड़े',
        totalearned: 'कमाई गए सिक्के',
        redeem: 'रिडीम किया गया राशि',
        offers: 'ऑफर की कोशिश की गई',
        refer: 'रेफरल',
      },
    },
    wallet: {
      title: 'वॉलेट शेष',
      redeem: 'अब रिडीम करें',
      earning: 'कमाई का इतिहास',
      transaction: 'लेन-देन का इतिहास',
    },
    redeem: {
      store: {
        title: 'रिडीम स्टोर',
        maxredemption: 'अनुमत मोचन की अधिकतम संख्या तक पहुंच गई है।',
        noredeemoption: (
          <>
            <p>वर्तमान में कोई रिडीम विकल्प उपलब्ध नहीं है</p>
            <p>
              कृपया बाद में पुनः प्रयास करें या हमारी सहायता टीम से संपर्क करें।
            </p>
          </>
        ),
      },
      pack: {
        nodata: 'एक बार पैक उपलब्ध हो जाने पर आप उन्हें यहां देखेंगे।',
      },
      payout: {
        form: {
          title: 'रिडीम करें',
          placeholder: 'अपना भुगतान पता दर्ज करें',
          noemail:
            'इस पैक के लिए आपके प्रोफ़ाइल में एक ईमेल पता सेट होना आवश्यक है।',
          cta: 'आगे बढ़ें',
          confirmdialog: {
            title: 'क्या आप सुनिश्चित हैं?',
            address: 'भुगतान पता:',
            amount: 'राशि:',
            confirm: 'पुष्टि करें',
            cancel: 'रद्द करें',
          },
        },
        status: {
          note: 'नोटः',
          reason: 'कारण:',
          rateus: 'प्ले स्टोर पर हमें रेट करें',
          processing: {
            title: 'भुगतान प्रसंस्करण',
            description:
              'भुगतान आम तौर पर 6 घंटे के भीतर आपके खाते में जमा कर दिया जाता है। तब तक, आपके सिक्के हमारे पास सुरक्षित हैं।',
          },
          processed: 'भुगतान सफल हुआ',
          failed: 'भुगतान विफल रहा',
          stillprocess: {
            title: 'भुगतान अभी भी प्रक्रियाधीन है',
            description:
              'एक भुगतान अनुरोध भेजा गया है. विफलता की स्थिति में वॉलेट को रिफंड जारी किया जाएगा।',
          },
        },
        crypto: {
          download: {
            title: 'क्या आपके पास लाइटनिंग एड्रेस नहीं है?',
            cta: 'यहां ZBD डाउनलोड करें!',
          },
          info: {
            title: 'ZBD ऐप में लाइटनिंग एड्रेस कैसे खोजें?',
            steps: [
              {
                title: 'प्लेस्टोर से ZBD ऐप इंस्टॉल करें',
                cta: 'ZBD स्थापित करें',
              },
              {
                title: 'साइड मेन्यू प्रोफाइल आइकन पर क्लिक करें',
              },
              {
                title: 'उपयोगकर्ता नाम पर क्लिक करें',
                description:
                  'यह लाइटनिंग एड्रेस को आपके क्लिपबोर्ड पर कॉपी कर देगा',
              },
            ],
          },
        },
      },
    },
    spin: {
      title: 'घूमाओ और जीतो',
      description:
        'भाग्य चक्र को घूमाने के लिए भारतकोइन की भरी हुई बैग जीतने का मौका प्राप्त करें।',
      timer: {
        wait: 'के लिए प्रतीक्षा करें',
        end: 'अपने भाग्य का परीक्षण करने के लिए।',
      },
      cta: 'घूमाएं',
      completeoffer: {
        cta: 'अनलॉक करने के लिए एक कार्य पूरा करें',
        description: 'आपको स्पिन को अनलॉक करने के लिए एक ऑफर पूरा करना होगा!',
      },
      modal: {
        oops: 'उफ़!',
        better: 'अगली बार में भाग्य आपके साथ हो।',
        congrats: 'बधाई हो!',
        won: 'आपने जीत लिया है',
      },
      again: {
        title: 'और जीतने के लिए फिर से वापस आओ',
        cta: 'अन्य कार्यों का अन्वेषण करें',
      },
    },
    empty: {
      available: 'कोई डेटा मौजूद नहीं',
      data: 'कोई डेटा नहीं',
      found: 'डाटा प्राप्त नहीं हुआ',
      referrals: 'अभी तक कोई रेफरल नहीं',
      contest: {
        ongoing: 'कोई चल रही प्रतियोगिता नहीं',
        old: 'कोई पुरानी प्रतियोगिता नहीं',
      },
      offers: {
        ongoing: 'कोई चालू ऑफर नहीं',
        completed: 'कोई पूर्ण प्रस्ताव नहीं',
        found: 'कोई ऑफर नहीं मिला',
        resetFilterCta: 'फिल्टर रीसेट करें',
      },
      internet: 'कोई सक्रिय इंटरनेट कनेक्शन नहीं!',
    },
    toast: {
      refer: {
        copy: 'रेफरल कोड कॉपी किया गया',
        emptycode: 'कृपया रेफरल कोड दर्ज करें',
        notExist: 'रेफरल मौजूद नहीं है',
      },
      failed: 'साझा करने में विफल, कृपया पुनः प्रयास करें',
      redeem: {
        maxredemption:
          'अनुमत मोचन की अधिकतम संख्या तक पहुंच गई है। कृपया बाद में पुन: प्रयास करें।',
        pack: 'यह पैक फिलहाल उपलब्ध नहीं है',
        validaddress: 'कृपया एक वैध भुगतान पता दर्ज करें',
        invalid: 'अमान्य ईमेल आईडी',
      },
      loginfailed: 'Google लॉगिन विफल रहा',
    },
    dialog: {
      offline: {
        title: 'उफ़, इंटरनेट कनेक्शन नहीं है',
        description:
          'उपलब्ध ऑफ़र तक पहुंचने के लिए कृपया अपना वाईफाई या मोबाइल डेटा चालू करें।',
      },
      error: {
        title: 'कुछ गलत हो गया है',
        description:
          'यह आप नहीं, यह हम हैं! <br /> चिंता न करें, फिर से कोशिश करें।',
        cta: 'पुनः प्रयास करें',
      },
      notfound: {
        title: '404 | पेज नहीं मिला',
        description: 'आप जिस पेज को खोज रहे हैं वह नहीं मिला है।',
        cta: 'ऑफ़र खोजें',
      },
      enableUsagePermission: {
        title: 'उपयोग एक्सेस सक्षम करें',
        description:
          'अब इस ऑफर से अद्भुत पुरस्कार प्राप्त करने के लिए उपयोग एक्सेस सक्षम करें!',
        cta: 'सक्षम करें',
      },
      confirmAlert: {
        cta: {
          confirm: 'पुष्टि करें',
          cancel: 'रद्द करें',
        },
      },
      banned: {
        heading: 'आप CashPlay का उपयोग करने से प्रतिबंधित हैं।',
        description:
          'यदि आपको लगता है कि यह एक गलती है, तो कृपया सहायता से संपर्क करें',
      },
      editProfile: {
        name: 'नाम',
      },
      fraud: {
        vpn: {
          title: 'ओह, हमने VPN का पता लगाया है',
          desc: 'सुनिश्चित करने के लिए कि आपको एक सुचारू और सुरक्षित अनुभव हो, आपको VPN बंद करना होगा।',
        },
        rooted: {
          title: 'ओह, हमने एक रूटेड डिवाइस का पता लगाया है',
          desc: 'सुनिश्चित करने के लिए कि आपको एक सुचारू और सुरक्षित अनुभव हो, आपको एक गैर-रूटेड डिवाइस का उपयोग करना होगा।',
        },
        modApp: {
          title: 'ओह, हमने पाया कि आप एक मोड ऐप का उपयोग कर रहे हैं',
          desc: 'सुनिश्चित करने के लिए कि आपको एक सुचारू और सुरक्षित अनुभव हो, आपको सही ऐप डाउनलोड करना होगा।',
        },
        developerOptions: {
          title: 'ओह, हमने पाया कि डेवलपर विकल्प चालू हैं',
          desc: 'सुनिश्चित करने के लिए कि आपको एक सुचारू और सुरक्षित अनुभव हो, आपको डेवलपर विकल्प बंद करने होंगे।',
        },
        emulator: {
          title: 'ओह, हमने एक एमुलेटर का पता लगाया है',
          desc: 'सुनिश्चित करने के लिए कि आपको एक सुचारू और सुरक्षित अनुभव हो, कृपया इसे सामान्य ऐप में उपयोग करें।',
        },
        blacklistedApp: fraud => ({
          title: 'चेतावनी! संदिग्ध ऐप का पता चला',
          desc: (
            <div>
              <p className="mb-4">
                {`कृपया ऐप का उपयोग करने के लिए नीचे सूचीबद्ध ऐप्स को अनइंस्टॉल करें`}
              </p>
              {fraud?.data?.map((d, index) => (
                <p key={index} className="my-1 text-color text-md ">
                  {d}
                </p>
              ))}
            </div>
          ),
        }),
        clone: {
          title: 'ओह, हमने पाया कि आपका डिवाइस क्लोन किया गया है',
          desc: 'सुनिश्चित करने के लिए कि आपको एक सुचारू और सुरक्षित अनुभव हो, आपको गैर-क्लोन डिवाइस का उपयोग करना होगा।',
        },
      },
    },
    forceUpdate: {
      title:
        'नमस्ते! हमने अभी-अभी अपने ऐप के लिए एक नया अपडेट जारी किया है जिसमें शानदार नए फीचर्स, सुधार और बग फिक्स शामिल हैं। कृपया इसे अभी इंस्टॉल करें और बेहतरीन अनुभव का आनंद लें। धन्यवाद!',
      cta: 'अपडेट करें',
    },
  },
  GUJARATI: {
    login: {
      title: 'CashPlay માં આપનું સ્વાગત છે',
      cta: 'Google સાથે લૉગિન કરો',
      phoneLogin: {
        title: 'ફોન નંબરથી લોગિન કરો',
        enterPhone: 'ફોન નંબર દાખલ કરો',
        phoneDescription:
          'OTP પ્રાપ્ત કરવા માટે કૃપા કરીને તમારો ફોન નંબર દાખલ કરો.',
        getOtp: 'OTP મેળવો',
        enterOtp: 'OTP દાખલ કરો',
        otpDescription: 'કૃપા કરીને તમારા ફોન પર મોકલવામાં આવેલ OTP દાખલ કરો.',
        submit: 'જમા કરો',
        retryOtp: '{timer} સેકન્ડમાં OTP ફરીથી પ્રયાસ કરો',
        resendOtp: 'OTP ફરીથી મોકલો',
      },
    },
    signup: {
      referralLabel: 'કોડ રિડીમ કરો',
      referralPlaceholder: 'રેફરલ કોડ દાખલ કરો',
      nameLabel: 'તમારું નામ',
      namePlaceholder: 'તમારું સંપૂર્ણ નામ દાખલ કરો',
      submit: 'સબમિટ કરો',
      skip: 'છોડો',
    },
    home: {
      notification: {
        title: 'સૂચના પરવાનગી સક્ષમ કરો',
        description:
          'તમારી કમાણીની મુસાફરી પર ત્વરિત અપડેટ્સ મેળવવા માટે સૂચનાઓ સક્ષમ કરો.',
        btn: 'સક્ષમ કરો',
      },
      sdk: {
        play: 'રમો અને કમાઓ',
        survey: 'સર્વે પારિતોષિકો',
        spin: 'સ્પિન અને વિન',
        games: 'રમતો',
      },
      filters: {
        title: 'ફિલ્ટર',
        selected: 'પસંદ કરેલ',
        type: 'ઓફર પ્રકાર',
        category: 'ઓફર કેટેગરી',
        applyAction: 'લાગુ કરો',
        clearAll: 'બધા સાફ કરો',
      },
      tags: {
        SINGLE_STEP: 'એક-પગથિયું',
        MULTI_REWARD: 'મલ્ટી-રિવોર્ડ',
        GAMING: 'ગેમિંગ',
        FINANCE: 'વિત્ત',
        SURVEY: 'સર્વે',
        DEPOSIT: 'ડિપોઝિટની જરૂર',
        NEW: 'નવું',
      },
      sort: {
        title: 'સૉર્ટ',
        default: 'ડિફૉલ્ટ (પ્રાસંગિકતા)',
        ttfp: 'સમય',
        price: 'ઇનામ',
        highToLow: 'ઉચ્ચ થી નીચું',
        lowToHigh: 'નીચા થી ઉચ્ચ',
      },
    },
    nav: {
      wallet: 'વૉલેટ બેલેન્સ',
      home: 'હોમ',
      offers: 'ઓફર કરે છે',
      refer: 'સંદર્ભ લો',
      contest: 'સ્પર્ધા',
      settings: 'સેટિંગ્સ',
      back: 'પાછળ',
      logout: 'લૉગ આઉટ',
      logoutmodal: 'શું તમે ખરેખર લોગઆઉટ કરવા માંગો છો',
    },
    dailycheckin: {
      notclaimed: {
        header: {
          title: 'અભિનંદન',
          description: 'દિવસભરની અદ્ભુત પુરસ્કારો કમાવવા માટે પ્રતિદિન આવો.',
        },
        footer: {
          description:
            'તમારું પુરસ્કાર દાવા માટે તૈયાર છે. તમારો પુરસ્કાર દાવા કરવા માટે નીચેનું બટન ક્લિક કરો.',
          cta: 'દાવો',
          offercta: 'દાવા કરવા માટે એક ઓફર પૂરી કરો',
        },
      },
      claiming: {
        congrats: 'અભિનંદન!',
        reward: 'તમે એક પુરસ્કાર મેળવ્યું છે',
        success: 'તમે સફળતાપૂર્વક દાવો કર્યો છે',
      },
      claimed: {
        reward: 'તમારા પુરસ્કારો',
        nextreward: 'તમારું આગલું પુરસ્કાર માં',
        day: 'દિવસ',
      },
    },
    settings: {
      title: 'સેટિંગ્સ',
      profile: 'પ્રોફાઇલ',
      help: 'મદદ',
      tc: 'ટીસી',
      privacy: 'ગોપનીયતા',
      contact: 'સંપર્ક કરો',
      language: 'ભાષા',
      description:
        'ઇમેઇલ દ્વારા અમારો સંપર્ક કરવા માટે કૃપા કરીને નીચેના બટનનો ઉપયોગ કરો',
    },
    offers: {
      title: 'ઓફર્સ',
      all: 'બધા ઓફર્સ',
      ongoing: 'ચાલુ છે',
      availed: 'ઉપયોગમાં',
      expired: 'સમાપ્ત',
      supporthead: 'સરેરાશ ઇનામ સમય',
      avgTime: 'સરેરાશ ઇનામ સમય',
      comment: {
        error: 'કૃપા કરીને ઓછામાં ઓછા 30 અક્ષર દાખલ કરો',
        submitBtn: 'મોકલો',
        inputLabel: 'પ્રતિસાદ',
        feedback: 'તમારા પ્રતિસાદ માટે આભાર',
      },
      voteErrors: {
        5001: 'ઓફર શરૂ થવાની અગાઉ મત આપી શકતા નથી',
        5002: 'વોટની મર્યાદા પહોંચી ગઈ છે',
        5003: 'વોટિંગનો સમય મર્યાદા પસાર થઈ ગઈ છે',
        5005: 'ડાઉન વોટ માટે પ્રતિસાદ આવશ્યક છે',
        5006: 'પ્રતિસાદમાં અક્ષરોની સંખ્યા મર્યાદાથી બહાર છે',
      },
      type: {
        CPI: 'હમણાં લઇ લો',
        CPA: 'હવે પૂર્ણ કરો',
        CPR: 'અત્યારે નોંધાવો',
        'APK-INSTALL': 'હમણાં લઇ લો',
        'APK-REGISTER': 'અત્યારે નોંધાવો',
        CPL: 'હવે પૂર્ણ કરો',
        default: 'હવે પૂર્ણ કરો',
      },
      supportoffercard: {
        title: 'પુરસ્કાર માટે અનુમાનિત સમય: 3 દિવસ',
        description:
          'ક્યારેક વાર્તાકારો તમારા પુરસ્કારની પરિશોધન માટે 3 દિવસ સુધી લઈ શકે છે.',
      },
      nooffer: {
        title: 'માફ કરશો, તમે જે ઑફર શોધી રહ્યાં છો તે અમે શોધી શક્યા નથી.',
        cta: 'વધુ ઑફર્સનું અન્વેષણ કરો',
        ongoing: 'કોઈ ચાલુ ઓફર નથી',
        completed: 'કોઈ પૂર્ણ ઑફર્સ નથી',
        nooffer: 'કોઈ ઑફર્સ નથી',
      },
      offerNotAvailable: {
        title:
          'અમને ખુબ જ અફસોસ છે, પરંતુ આ ઓફર હાલમાં ઉપલબ્ધ નથી. કૃપા કરીને અમારા અન્ય ઓફરો શોધો.',
        cta: 'વધુ ઓફરો શોધો',
      },
      termscondition:
        'કોઈપણ ઓફર અથવા ઇવેન્ટમાં ભાગ લઈને, તમે અનુગામી નિયમો અને શરતો સાથે સંમત થાઓ છો. જો અમારા માટે જવાબદાર ન હોય તેવા સંજોગોને કારણે નિર્દિષ્ટ ધ્યેય હાંસલ કરવા માટે પુરસ્કાર આપવામાં ન આવે, તો આગળના પુરસ્કારો જપ્ત કરવામાં આવશે. કૃપા કરીને નોંધો કે પુરસ્કારો માટેની પાત્રતા માટે નવું એકાઉન્ટ બનાવવું જરૂરી છે; પૂર્વ-અસ્તિત્વમાં રહેલા એકાઉન્ટ્સ આ ચોક્કસ પુરસ્કાર માટે અયોગ્ય છે. નિયુક્ત એપ્લિકેશન માટે ઓફરમાં સ્પષ્ટ રીતે દર્શાવેલ સ્તરો પૂરા થવા પર પુરસ્કારો વિશેષરૂપે આપવામાં આવશે. વધુમાં, આ મલ્ટિ-રિવોર્ડ ઓફરને સમાન એપ્લિકેશનને લગતી સમવર્તી ઑફર્સ સાથે જોડી શકાતી નથી. નિયુક્ત સ્તરોને પૂર્ણ કરવા માટે બહુવિધ પુરસ્કારો મેળવવા માટે, કૃપા કરીને નીચેના બટનને ક્લિક કરો અને એપ્લિકેશન શરૂ કરો. તે જાણવું અગત્યનું છે કે આ નિયમો અને શરતો સાર્વત્રિક રીતે તમામ ઑફર્સ અને ઇવેન્ટ્સ પર લાગુ થાય છે; જો કે, ચોક્કસ વિગતો વ્યક્તિગત પ્રમોશન અનુસાર બદલાઈ શકે છે. ભાગ લેતા પહેલા દરેક ઓફર માટે યોગ્ય શરતોની સમીક્ષા કરવાની સલાહ આપવામાં આવે છે.',
      disclaimer: {
        title: 'ઇન્કાર',
        points: [
          'એપ્લિકેશનને તમારા ઉપકરણ પર છેલ્લા 30 દિવસોમાં ઇન્સ્ટોલ કરવું ન હોવું જોઈએ.',
          'બધા પગલાં પૂરા થયા પછી પુરસ્કાર આપવામાં આવશે.',
          'વિઝ્ઞાપનદાતા પાસેથી પુષ્ટિ પછી જ પુરસ્કાર આપવામાં આવશે.',
          'વીઝ्ञાપનદાતાને પુરસ્કારની પુષ્ટિ કરવા માટે 24 કલાક લાગી શકે છે.',
          'વિપીએનનો ઉપયોગ સહિતની કોઈપણ છેતરપીંડી પ્રવૃત્તિ પરિણામે ખાતા પર પ્રતિબંધ મૂકશે.',
        ],
      },
      details: {
        steps: 'સૂચનાઓ',
        support: 'સમસ્યાઓનો સામનો કરી રહ્યા છો?',
        reach: 'અમારો સંપર્ક કરો',
        terms: 'શરતો અને નિયમો',
        read: 'વધુ વાંચો',
        btnactions: {
          open: 'એપ્લિકેશન ખોલો',
          get: 'મેળવો',
        },
        status: {
          chips: {
            expired: 'સમાપ્ત',
            useapp: 'એપ્લિકેશનનો ઉપયોગ કરવાની રાહ જોઈ રહ્યાં છીએ',
            waiting: 'રાહ જોઈ રહ્યા છે',
            ongoing: 'અત્યારે ચાલુ છે',
            unlock: 'અનલૉક થવાની રાહ જોઈ રહ્યાં છીએ',
            completed: 'પૂર્ણ થયું',
          },
          expired: {
            title: 'આ ઓફર સમાપ્ત થઈ ગઈ છે!',
            description:
              'એવું લાગે છે કે આ ઑફર હવે ઉપલબ્ધ નથી. તમારો આગલો પુરસ્કાર મેળવવા માટે વધુ ઑફરોનું અન્વેષણ કરો!',
          },
          cpl: {
            title: 'પૂર્ણ કરવાનો સમય',
          },
          ongoing: {
            title: 'તમારો પુરસ્કાર તેના માર્ગ પર છે!',
            description:
              'કેટલીકવાર જાહેરાતકર્તાઓ તમારી ક્રિયાની પુષ્ટિ કરવા માટે 3 દિવસ જેટલો સમય લે છે. વધુ પુરસ્કારો માટે અન્ય ઑફરો તપાસો!',
          },
          retention: {
            unlock: 'આગામી પુરસ્કારને અનલૉક કરવાનો સમય',
            ongoing: 'એપ્લિકેશન ખોલો અને અન્વેષણ કરો!',
            description:
              'તમે જેટલો વધુ એપનો ઉપયોગ કરશો, તેટલી વધુ પુરસ્કારો મેળવવાની ખાતરી.',
          },
          completed: {
            title: 'અભિનંદન!',
            description:
              'આ ઑફર પૂર્ણ કરવા બદલ પુરસ્કૃત. તમારો આગલો પુરસ્કાર મેળવવા માટે વધુ ઑફરોનું અન્વેષણ કરો!',
          },
        },
      },
      support: [
        {
          question: 'અયોગ્ય પુરસ્કાર મૂલ્ય પ્રાપ્ત થયું',
          answer:
            'તમે ઉપરોક્ત ઓફર માટે સપોર્ટ ક્વેરી કરી શકો છો. તમે શરૂ કરેલી ઑફર્સમાં કોઈ સમસ્યા હોય તો કૃપા કરીને અમને જણાવો',
          action: 'અમારો સંપર્ક કરો',
        },
        {
          question: 'ઓફર માટે પુરસ્કાર પ્રાપ્ત થયો નથી',
          answer:
            'તમે ઉપરોક્ત ઓફર માટે સપોર્ટ ક્વેરી કરી શકો છો. તમે શરૂ કરેલી ઑફર્સમાં કોઈ સમસ્યા હોય તો કૃપા કરીને અમને જણાવો',
          action: 'અમારો સંપર્ક કરો',
        },
        {
          question:
            'મેં ઓફરમાં દર્શાવેલ તમામ સ્ટેપ્સ પૂર્ણ કરી લીધા છે, પરંતુ મારી ઓફર હજુ પણ ચાલુ છે. હવે હું શું કરી શકું?',
          answer: (
            <>
              <ul className="pl-4 mt-1 list-disc">
                <li>
                  જ્યારે અમે તમારી પૂર્ણતા ચકાસતા હોઈએ ત્યારે ચાલુ ઑફર્સમાં પણ
                  ઑફર બતાવવામાં આવશે.
                </li>
                <li>
                  કૃપા કરીને ખાતરી કરો કે તમે પુરસ્કાર માટે લાયક બનવા માટે
                  ઓછામાં ઓછી 5 મિનિટ માટે એપ્લિકેશનનો ઉપયોગ કર્યો છે.
                </li>
              </ul>
            </>
          ),
        },
      ],
    },
    help: {
      title: 'વારંવાર પૂછાતા પ્રશ્નો',
      header: {
        title: (
          <>
            વિશે અમને કહો <br className="portrait:hidden" /> સમસ્યાઓ કે જે તમે
            સામનો કરી રહ્યા છો
          </>
        ),
        description: 'જવાબ આપવાનો આદર્શ સમય 24 કલાકથી ઓછો છે',
      },
      support: {
        title: 'સમસ્યાનો સામનો કરી રહ્યાં છો? અમારી સાથે વાત કરો',
        cta: 'અમારો સંપર્ક કરો',
      },
      items: [
        {
          question: 'હું ઑફર કેવી રીતે મેળવી શકું?',
          answer: (
            <>
              ઑફરનો લાભ લેવા માટે આ પગલાં અનુસરો:
              <ul className="pl-4 mt-1 list-disc">
                <li>ઑફરની વિગતો જોવા માટે ઑફર પર ક્લિક કરો.</li>
                <li>
                  બધા પગલાંઓ કાળજીપૂર્વક વાંચો અને એક પછી એક બધા પગલાંઓ કરો.
                </li>
                <li>
                  એકવાર અમે ખરાઈ કરી લઈએ કે કાર્યો પૂર્ણ થઈ ગયા પછી પુરસ્કારો
                  આપવામાં આવશે.
                </li>
              </ul>
            </>
          ),
        },
        {
          question: 'મને પુરસ્કારો ક્યારે મળશે?',
          answer:
            'એકવાર અમે ચકાસો કે તમે ઑફરમાં ઉલ્લેખિત તમામ પગલાં પૂર્ણ કરી લીધાં છે તે પછી તમને પુરસ્કારો પ્રાપ્ત થશે.',
        },
        {
          question: 'ચાલુ ઓફર શું છે?',
          answer:
            'ચાલુ ઑફર એ છે જે તમે આંશિક રીતે પૂર્ણ કરી હોય, એટલે કે, જ્યાં તમે બધા પગલાં પૂર્ણ કર્યા નથી અથવા અમે તમારી પૂર્ણતાને ચકાસવાની પ્રક્રિયામાં છીએ.',
        },
        {
          question:
            'મેં ઓફરમાં દર્શાવેલ તમામ સ્ટેપ્સ પૂર્ણ કરી લીધા છે, પરંતુ મારી ઓફર હજુ પણ ચાલુ છે. હવે હું શું કરી શકું?',
          answer: (
            <>
              <ul className="pl-4 mt-1 list-disc">
                <li>
                  જ્યારે અમે તમારી પૂર્ણતા ચકાસતા હોઈએ ત્યારે ચાલુ ઑફર્સમાં પણ
                  ઑફર બતાવવામાં આવશે.
                </li>
                <li>
                  કૃપા કરીને ખાતરી કરો કે તમે પુરસ્કાર માટે લાયક બનવા માટે
                  ઓછામાં ઓછી 5 મિનિટ માટે એપ્લિકેશનનો ઉપયોગ કર્યો છે.
                </li>
              </ul>
            </>
          ),
        },
        {
          question: 'હું પુરસ્કારો કેવી રીતે પ્રાપ્ત કરી શકું?',
          answer:
            'ઑફર સફળતાપૂર્વક પૂર્ણ થવા પર પુરસ્કારો આપમેળે તમારા વૉલેટમાં ઉમેરવામાં આવશે.',
        },
      ],
    },
    refer: {
      title: 'રેફર અને કમાણી',
      redirect: 'રીડાયરેક્ટ કરી રહ્યું છે...',
      view: 'રેફરલ્સ જોવાય',
      refercta: 'હવે એક મિત્રનું રેફર કરો',
      share: 'રેફર કોડ',
      howto: {
        title: 'તે કેવી રીતે કામ કરે છે',
        items: [
          {
            title: 'તમારા મિત્રોને આમંત્રિત કરો',
            description: 'ફક્ત તમારું લિંક શેર કરો',
          },
          {
            title: 'શુભારંભ',
            description: 'જ્યારે તમારો મિત્ર 3 ઓફર્સ પૂર્ણ કરે',
          },
          {
            title: `તમે 3 ઓફર્સ પર તેમને કરતાં મળેલા ${REFERRAL_WINNING_PERCENTANGE}% કમાવો`,
            description: 'તમારો મિત્ર પ્રથમ 3 ઓફર્સ પર વધુ 5% કમાવે',
          },
          {
            title: 'તમે ઘણા મિત્રોનું રેફર કરી શકો છો',
            description: 'પસીનું ભરવા સમય છોડો અને આરામ કરો',
          },
        ],
      },
      list: {
        title: 'તમારા રેફરલ્સ',
        description:
          'તમારા રેફરલ્સ ક્યારેય રેફરલ સિકોન્સ મેળવવા માટે એક સેટની લક્ષણો પૂરા કરવી જોઈએ.',
        offerscompleted: 'ઓફર્સ પૂરી કરી ગયી',
      },
    },
    contest: {
      tabs: {
        ongoing: 'અત્યારે ચાલુ છે',
        older: 'જૂની',
        stats: 'તમારા આંકડા',
        leaderboard: 'લીડરબોર્ડ',
        rules: 'નિયમો',
      },
      leaderboard: {
        loading: 'લોડ કરી રહ્યું છે...',
        rank: 'તમારી રેન્ક',
        prize: 'ઇનામ',
        update: 'છેલ્લે અપડેટ કરેલ:',
        offertype: {
          offer: 'ઓફર કરે છે',
          refer: 'રેફરલ્સ',
        },
      },
      modal: {
        joined: 'હરીફાઈમાં જોડાયા',
        offertype: {
          offer: (
            <>
              જીતવાનું શરૂ કરો,
              <br />
              સંપૂર્ણ ઓફર્સ
            </>
          ),
          refer: (
            <>
              જીતવાનું શરૂ કરો,
              <br />
              સંદર્ભ આપવાનું શરૂ કરો
            </>
          ),
        },
        cta: 'કમાણી શરૂ કરો',
      },
      status: {
        title: 'સ્પર્ધા',
        close: 'બંધ',
        ends: 'માં સમાપ્ત થાય છે',
        starts: 'માં શરૂ થાય છે',
        headers: {
          completed: 'આ હરીફાઈ પૂરી થઈ ગઈ છે.',
          refer: 'મિત્રોને સંદર્ભિત કરવા બદલ પુરસ્કારો કમાઓ.',
          offer: 'મહત્તમ ઑફર્સ પૂર્ણ કરવા બદલ પુરસ્કારો કમાઓ.',
        },
      },
      join: 'હમણાં જોડાઓ',
      freejoin: 'મફત',
      minimumBalance: ({ value, currency }) => (
        <>
          જોડાવવા માટે તમારા પાસે {value} {currency} હોવું જોઈએ
        </>
      ),
      insufficientBalance: 'પૂરતું બેલેન્સ નથી',
      rankcard: {
        rank: 'તમારી રેન્ક',
        reward: 'તમારો પુરસ્કાર',
        top: 'ટોચ પર રહેવા માટે ઓફરો પૂર્ણ કરતું રહો',
        climb: 'લીડરબોર્ડ પર ચઢવા માટે ઓફરો પૂર્ણ કરતું રહો',
        cta: 'ઑફર્સ પર જાઓ',
      },
      refercard: {
        title: 'સંદર્ભ લો અને તેના દ્વારા કમાઓ',
        invite: 'રેફરલ કોડ દ્વારા આમંત્રિત કરો',
        copy: 'નકલ કરો',
      },
      contestcard: {
        register: 'રજીસ્ટર',
        join: {
          profilejoined: 'તમે હરીફાઈમાં જોડાયા છો, કાર્યો કરીને કમાણી શરૂ કરો!',
          joined: 'હરીફાઈમાં જોડાયા',
          cta: 'હવે જોડાઓ',
        },
        rank: 'તમારી રેન્ક',
        reward: 'તમારો પુરસ્કાર',
        entry: 'પ્રવેશ',
        free: 'મફત',
        maxreward: 'મહત્તમ પુરસ્કાર',
        details: 'વિગતો જુઓ',
      },
      rewardcard: {
        title: 'હરીફાઈ પુરસ્કારો',
        rank: 'રેન્ક',
        reward: 'પારિતોષિકો',
      },
      errorboundary: {
        header: {
          title: 'અરે!',
          description: 'કંઈક ખોટું થયું.',
        },
        description:
          'અસુવિધા બદલ અમે દિલગીર છીએ. ફરીથી પ્રયાસ કરવા માટે એપ્લિકેશનને બંધ કરો અને ફરીથી ખોલો. જો સમસ્યા ચાલુ રહે, તો કૃપા કરીને સમસ્યાની જાણ કરો.',
        feedbackcta: 'પ્રતિસાદની જાણ કરો',
        retrycta: 'ફરી પ્રયાસ કરો',
      },
    },
    profile: {
      title: 'પ્રોફાઇલ',
      earning: 'ત્યારથી કમાણી',
      stats: {
        title: 'આંકડા',
        totalearned: 'સિક્કા કમાયા',
        redeem: 'રિડીમ કરેલ રકમ',
        offers: 'ઑફર્સનો પ્રયાસ કર્યો',
        refer: 'રેફરલ્સ',
      },
    },
    wallet: {
      title: 'વૉલેટ બેલેન્સ',
      redeem: 'અત્યારે જ મેળવો',
      earning: 'કમાણીનો ઇતિહાસ',
      transaction: 'વ્યવહાર ઇતિહાસ',
    },
    redeem: {
      store: {
        title: 'રિડીમ સ્ટોર',
        maxredemption: 'મંજૂર રિડેમ્પશનની મહત્તમ સંખ્યા પહોંચી ગઈ છે.',
        noredeemoption: (
          <>
            <p>હાલમાં કોઈ રિડીમ વિકલ્પો ઉપલબ્ધ નથી</p>
            <p>
              કૃપા કરીને પછીથી ફરી પ્રયાસ કરો અથવા અમારી સપોર્ટ ટીમનો સંપર્ક
              કરો.
            </p>
          </>
        ),
      },
      pack: {
        nodata: 'એકવાર તે ઉપલબ્ધ થઈ જાય તે પછી તમે અહીં પેક જોશો.',
      },
      payout: {
        form: {
          title: 'મુકવું',
          placeholder: 'તમારું ચુકવણી સરનામું દાખલ કરો',
          noemail:
            'આ પેક માટે તમારી પ્રોફાઇલમાં એક ઇમેઇલ સરનામું સેટ કરવું જરૂરી છે.',
          cta: 'આગળ વધો',
          confirmdialog: {
            title: 'શું તમે ખરેખર ખોટું છો?',
            address: 'ચુકવણી સરનામું:',
            amount: 'રકમ:',
            confirm: 'પુષ્ટિ કરો',
            cancel: 'રદ કરો',
          },
        },
        status: {
          note: 'નૉૅધ:',
          reason: 'કારણ:',
          rateus: 'અમને પ્લે સ્ટોર પર રેટ કરો',
          processing: {
            title: 'ચુકવણી પ્રક્રિયા',
            description:
              'ચુકવણી સામાન્ય રીતે 6 કલાકની અંદર તમારા ખાતામાં જમા થઈ જાય છે. ત્યાં સુધી તમારા સિક્કા અમારી પાસે સુરક્ષિત છે.',
          },
          processed: 'ચુકવણી સફળ',
          failed: 'ચુકવણી નિષ્ફળ',
          stillprocess: {
            title: 'ચુકવણીની પ્રક્રિયા હજી ચાલુ છે',
            description:
              'ચુકવણીની વિનંતી મોકલવામાં આવી છે. નિષ્ફળતાના કિસ્સામાં વોલેટમાં રિફંડ જારી કરવામાં આવશે.',
          },
        },
        crypto: {
          download: {
            title: 'લાઈટનિંગ સરનામું નથી?',
            cta: 'ZBD અહીં ડાઉનલોડ કરો!',
          },
          info: {
            title: 'ZBD એપ્લિકેશનમાં વીજળીનું સરનામું કેવી રીતે શોધવું?',
            steps: [
              {
                title: 'પ્લેસ્ટોર પરથી ZBD એપ ઇન્સ્ટોલ કરો',
                cta: 'ZBD ઇન્સ્ટોલ કરો',
              },
              {
                title: 'સાઇડ મેનુ પ્રોફાઇલ આઇકોન પર ક્લિક કરો',
              },
              {
                title: 'વપરાશકર્તા નામ પર ક્લિક કરો',
                description: 'આ તમારા ક્લિપબોર્ડ પર વીજળીના સરનામાની નકલ કરશે',
              },
            ],
          },
        },
      },
    },
    spin: {
      title: 'સ્પિન અને વિન',
      description:
        'નસીબના ચક્રને ફરતા કરવા માટે Gems ની ભરેલી બેગ જીતવાની તક મેળવો.',
      timer: {
        wait: 'માટે રાહ',
        end: 'તમારું નસીબ ચકાસવા માટે.',
      },
      cta: 'સ્પિન',
      completeoffer: {
        cta: 'અનલૉક કરવા માટે એક કાર્ય પૂર્ણ કરો',
        description: 'સ્પિનને અનલૉક કરવા માટે તમારે એક ઑફર પૂર્ણ કરવી પડશે!',
      },
      modal: {
        oops: 'અરે!',
        better: 'આગલી વખતે સારા નસીબ',
        congrats: 'અભિનંદન!',
        won: 'તું જીતી ગયો',
      },
      again: {
        title: 'વધુ જીતવા માટે ફરી પાછા આવો',
        cta: 'અન્ય કાર્યોનું અન્વેષણ કરો',
      },
    },
    empty: {
      available: 'કોઈ ડેટા ઉપલબ્ધ નથી',
      data: 'કોઈ ડેટા નથી',
      found: 'કોઈ ડેટા મળ્યો નથી',
      referrals: 'હજુ સુધી કોઈ રેફરલ્સ નથી',
      contest: {
        ongoing: 'કોઈ ચાલુ સ્પર્ધાઓ નથી',
        old: 'કોઈ જૂની સ્પર્ધાઓ નથી',
      },
      offers: {
        ongoing: 'કોઈ ચાલુ ઓફર નથી',
        completed: 'કોઈ પૂર્ણ ઑફર્સ નથી',
        found: 'કોઈ ઑફર્સ મળી નથી',
        resetFilterCta: 'ફિલ્ટરો ફરીથી સેટ કરો',
      },
      internet: 'કોઈ સક્રિય ઇન્ટરનેટ કનેક્શન નથી!',
    },
    toast: {
      refer: {
        copy: 'રેફરલ કોડ કૉપિ કર્યો',
        emptycode: 'કૃપા કરીને રેફરલ કોડ દાખલ કરો',
        notExist: 'રેફરલ અસ્તિત્વમાં નથી',
      },
      failed: 'શેર કરવામાં નિષ્ફળ, કૃપા કરીને ફરી પ્રયાસ કરો',
      redeem: {
        maxredemption:
          'મંજૂર રિડેમ્પશનની મહત્તમ સંખ્યા પહોંચી ગઈ છે. પછીથી ફરી પ્રયત્ન કરો.',
        pack: 'આ પેક અત્યારે ઉપલબ્ધ નથી',
        validaddress: 'કૃપા કરીને માન્ય ચુકવણી સરનામું દાખલ કરો',
        invalid: 'અમાન્ય ઈમેલ આઈડી',
      },
      loginfailed: 'Google લૉગિન નિષ્ફળ થયું',
    },
    dialog: {
      offline: {
        title: 'અરે, ઇન્ટરનેટ કનેક્શન નથી',
        description:
          'ઉપલબ્ધ ઑફર્સને ઍક્સેસ કરવા માટે કૃપા કરીને તમારો WiFi અથવા મોબાઇલ ડેટા ચાલુ કરો.',
      },
      error: {
        title: 'કંઈ ખોટું થયું',
        description:
          'આ તમે નથી, આ અમે છીએ! <br /> ઘબરાવતા ન રહો, ફરીથી પ્રયાસ કરો.',
        cta: 'પુનઃ પ્રયાસ કરો',
      },
      notfound: {
        title: '404 | પેજ નથી મળ્યું',
        description: 'તમે જે પેજ શોધી રહ્યા છો તે મળ્યું નથી.',
        cta: 'ઑફર્સનું અન્વેષણ કરો',
      },
      enableUsagePermission: {
        title: 'વપરાશ ઍક્સેસ સક્ષમ કરો',
        description:
          'હવે આ ઓફરમાંથી અદ્ભુત ઇનામ મેળવવા માટે વપરાશ ઍક્સેસ સક્ષમ કરો!',
        cta: 'સક્ષમ કરો',
      },
      confirmAlert: {
        cta: {
          confirm: 'ખાતરી કરો',
          cancel: 'રદ કરો',
        },
      },
      banned: {
        heading: 'તમે CashPlay વાપરવા માટે પ્રતિબંધિત છો.',
        description:
          'જો તમને લાગે કે આ ભૂલ છે, તો કૃપા કરીને સપોર્ટનો સંપર્ક કરો',
      },
      editProfile: {
        name: 'નામ',
      },
      fraud: {
        vpn: {
          title: 'અરે, અમે VPN શોધી છે',
          desc: 'સुनિશ્ચિત કરવા માટે કે તમને સુચારૂ અને સુરક્ષિત અનુભવ મળે, તમારે VPN બંધ કરવું પડશે.',
        },
        rooted: {
          title: 'અરે, અમે એક રૂટેડ ડિવાઈસ શોધી છે',
          desc: 'સुनિશ્ચિત કરવા માટે કે તમને સુચારૂ અને સુરક્ષિત અનુભવ મળે, તમારે એક નોન-રૂટેડ ડિવાઈસનો ઉપયોગ કરવો પડશે.',
        },
        modApp: {
          title: 'અરે, અમે શોધ્યું કે તમે એક મોડ એપનો ઉપયોગ કરી રહ્યા છો',
          desc: 'સुनિશ્ચિત કરવા માટે કે તમને સુચારૂ અને સુરક્ષિત અનુભવ મળે, તમારે સાચી એપ ડાઉનલોડ કરવી પડશે.',
        },
        developerOptions: {
          title: 'અરે, અમે શોધ્યું કે ડેવલપર વિકલ્પો ચાલુ છે',
          desc: 'સुनિશ્ચિત કરવા માટે કે તમને સુચારૂ અને સુરક્ષિત અનુભવ મળે, તમારે ડેવલપર વિકલ્પો બંધ કરવું પડશે.',
        },
        emulator: {
          title: 'અરે, અમે એક એમ્યુલેટર શોધી છે',
          desc: 'સुनિશ્ચિત કરવા માટે કે તમને સુચારૂ અને સુરક્ષિત અનુભવ મળે, કૃપા કરીને તેને સામાન્ય એપમાં વાપરો.',
        },
        blacklistedApp: fraud => ({
          title: 'ચેતવણી! શંકાસ્પદ એપ મળી',
          desc: (
            <div>
              <p className="mb-4">
                {`કૃપા કરીને એપ વાપરવા માટે નીચે સૂચિબદ્ધ એપ્સને અનઇન્સ્ટોલ કરો`}
              </p>
              {fraud?.data?.map((d, index) => (
                <p key={index} className="my-1 text-color text-md ">
                  {d}
                </p>
              ))}
            </div>
          ),
        }),
        clone: {
          title: 'અરે, અમે શોધી કાઢ્યું કે તમારું ઉપકરણ ક્લોન કરાયું છે',
          desc: 'સુનિશ્ચિત કરવા માટે કે તમને એક સુચારૂ અને સુરક્ષિત અનુભવ મળે, તમારે નોન-ક્લોન ઉપકરણનો ઉપયોગ કરવો પડશે.',
        },
      },
    },
    forceUpdate: {
      title: `નમસ્તે! અમે હમણાં જ અમારા એપ માટે નવું અપડેટ રિલીઝ કર્યું છે, જેમાં શ્રેષ્ઠ નવા ફીચર્સ, સુધારા અને બગ ફિક્સિસ શામેલ છે. કૃપા કરીને તેને તાત્કાલિક ઇન્સ્ટોલ કરો અને શ્રેષ્ઠ અનુભવ માણો. આભાર!`,
      cta: 'અપડેટ કરો',
    },
  },
  MARATHI: {
    login: {
      title: 'CashPlay मध्ये आपले स्वागत आहे',
      cta: 'Google सह लॉगिन करा',
      phoneLogin: {
        title: 'फोन नंबरने लॉगिन करा',
        enterPhone: 'फोन नंबर प्रविष्ट करा',
        phoneDescription:
          'OTP प्राप्त करण्यासाठी कृपया आपला फोन नंबर प्रविष्ट करा.',
        getOtp: 'OTP मिळवा',
        enterOtp: 'OTP प्रविष्ट करा',
        otpDescription: 'कृपया आपल्या फोनवर पाठवलेला OTP प्रविष्ट करा.',
        submit: 'जमा करा',
        retryOtp: '{timer} सेकंदात OTP पुन्हा प्रयत्न करा',
        resendOtp: 'OTP पुन्हा पाठवा',
      },
    },
    signup: {
      referralLabel: 'कोडची पूर्तता',
      referralPlaceholder: 'रेफरल कोड एंटर करा',
      nameLabel: 'तुमचे नाव',
      namePlaceholder: 'तुमचे संपूर्ण नाव एंटर करा',
      submit: 'प्रस्तुत करणे',
      skip: 'वगळा',
    },
    home: {
      notification: {
        title: 'सूचना परवानगी सक्षम करा',
        description:
          'तुमच्या कमाईच्या प्रवासावर झटपट अपडेट मिळवण्यासाठी सूचना सक्षम करा.',
        btn: 'सक्षम करा',
      },
      sdk: {
        play: 'खेळा आणि कमवा',
        survey: 'सर्वेक्षण बक्षिसे',
        spin: 'फिरकी आणि विजय',
        games: 'खेळ',
      },
      filters: {
        title: 'फिल्टर',
        selected: 'निवडलेले',
        type: 'ऑफर प्रकार',
        category: 'ऑफर श्रेणी',
        applyAction: 'लागू करा',
        clearAll: 'सर्व साफ करा',
      },
      tags: {
        SINGLE_STEP: 'एक-चरण',
        MULTI_REWARD: 'मल्टी-रिवार्ड',
        GAMING: 'गेमिंग',
        FINANCE: 'वित्त',
        SURVEY: 'सर्वेक्षण',
        DEPOSIT: 'ठेव आवश्यक',
        NEW: 'नवीन',
      },
      sort: {
        title: 'क्रमबद्ध',
        default: 'डिफॉल्ट (संबंधितता)',
        ttfp: 'वेळ',
        price: 'बक्षीस',
        highToLow: 'उच्च ते निम्न',
        lowToHigh: 'निम्न ते उच्च',
      },
    },
    nav: {
      wallet: 'वॉलेट शिल्लक',
      home: 'होम',
      offers: 'ऑफर',
      refer: 'रेफर करा',
      contest: 'स्पर्धा',
      settings: 'सेटिंग्ज',
      back: 'मागे',
      logout: 'बाहेर पडणे',
      logoutmodal: 'तुमची खात्री आहे की तुम्ही लॉगआउट करू इच्छिता',
    },
    dailycheckin: {
      notclaimed: {
        header: {
          title: 'अभिनंदन',
          description: 'अद्भुत पुरस्कार मिळवण्यासाठी प्रत्येक दिवस येऊन बसा.',
        },
        footer: {
          description:
            'तुमचा पुरस्कार दावा करण्यासाठी तयार आहे. तुमचा पुरस्कार दावा करण्यासाठी खालील बटणावर क्लिक करा.',
          cta: 'दावा करा',
          offercta: 'दावा करण्यासाठी एक काम पूर्ण करा',
        },
      },
      claiming: {
        congrats: 'अभिनंदन!',
        reward: 'तुम्हाला एक पुरस्कार मिळाला आहे',
        success: 'तुम्ही सफळतेने दावा केला आहे',
      },
      claimed: {
        reward: 'तुमचे पुरस्कार',
        nextreward: 'तुमचे पुढील बक्षीस',
        day: 'दिवस',
      },
    },
    settings: {
      title: 'सेटिंग्ज',
      profile: 'प्रोफाइल',
      help: 'मदत करा',
      tc: 'टीसी',
      privacy: 'गोपनीयता',
      contact: 'संपर्क साधा',
      language: 'भाषा',
      description:
        'ईमेलद्वारे आमच्याशी संपर्क साधण्यासाठी कृपया खालील बटण वापरा',
    },
    offers: {
      title: 'ऑफर',
      all: 'सर्व ऑफर',
      ongoing: 'चालू आहे',
      availed: 'लाभलेले',
      expired: 'संपलेले',
      supporthead: 'सपोर्ट',
      avgTime: 'साधारण बक्षीस वेळ',
      comment: {
        error: 'कृपया किमान 30 अक्षरे प्रविष्ट करा',
        submitBtn: 'सादर करा',
        inputLabel: 'अभिप्राय',
        feedback: 'तुमच्या अभिप्रायाबद्दल धन्यवाद',
      },
      voteErrors: {
        5001: 'ऑफर सुरू होण्यापूर्वी मतदान करू शकत नाही',
        5002: 'मतांची कमाल संख्या गाठली आहे',
        5003: 'मतदानाची वेळ मर्यादा ओलांडली आहे',
        5005: 'डाउन व्होटसाठी अभिप्राय आवश्यक आहे',
        5006: 'अभिप्रायातील वर्णसंख्या मर्यादेबाहेर आहे',
      },
      type: {
        CPI: 'आता मिळवा',
        CPA: 'आता पूर्ण करा',
        CPR: 'अाता नोंदणी करा',
        'APK-INSTALL': 'आता मिळवा',
        'APK-REGISTER': 'अाता नोंदणी करा',
        CPL: 'आता पूर्ण करा',
        default: 'आता पूर्ण करा',
      },
      supportoffercard: {
        title: 'पुरस्कारासाठी अनुमानित कालावधी: 3 दिवस',
        description:
          'कधीकधी जाहिरातकारांना तुमच्या पुरस्काराची चाचणी करण्यासाठी 3 दिवसांपर्यंत लागू शकते.',
      },
      nooffer: {
        title: 'क्षमस्व, तुम्ही शोधत असलेली ऑफर आम्हाला सापडली नाही.',
        cta: 'अधिक ऑफर एक्सप्लोर करा',
        ongoing: 'कोणत्याही चालू ऑफर नाहीत',
        completed: 'पूर्ण झालेल्या ऑफर नाहीत',
        nooffer: 'कोणत्याही ऑफर नाहीत',
      },
      offerNotAvailable: {
        title:
          'आम्हाला दिलगीर आहे, परंतु हा ऑफर सध्या उपलब्ध नाही. कृपया आमच्या इतर ऑफर्स पाहा.',
        cta: 'इतर ऑफर्स पाहा',
      },
      termscondition:
        'कोणत्याही ऑफर किंवा कार्यक्रमात भाग घेऊन, तुम्ही त्यानंतरच्या अटी व शर्तींना सहमती देता. आमच्यासाठी कारणीभूत नसलेल्या परिस्थितीमुळे निर्दिष्ट उद्दिष्ट साध्य करण्यासाठी बक्षीस मंजूर केले गेले नाही तर, पुढील पुरस्कार जप्त केले जातील. कृपया लक्षात ठेवा की पुरस्कारांसाठी पात्रतेसाठी नवीन खाते तयार करणे आवश्यक आहे; आधीच अस्तित्वात असलेली खाती या विशिष्ट पुरस्कारासाठी अपात्र आहेत. नियुक्त केलेल्या अर्जासाठी ऑफरमध्ये स्पष्टपणे नमूद केलेले स्तर पूर्ण केल्यावरच बक्षिसे दिली जातील. शिवाय, ही मल्टी-रिवॉर्ड ऑफर समान अनुप्रयोगाशी संबंधित समवर्ती ऑफरसह एकत्र केली जाऊ शकत नाही. नियुक्त स्तर पूर्ण करण्यासाठी एकाधिक पुरस्कारांमध्ये प्रवेश करण्यासाठी, कृपया खालील बटणावर क्लिक करा आणि अनुप्रयोग सुरू करा. या अटी आणि शर्ती सर्व ऑफर आणि कार्यक्रमांना सार्वत्रिकपणे लागू होतात याची जाणीव असणे महत्त्वाचे आहे; तथापि, वैयक्तिक जाहिरातींनुसार विशिष्ट तपशील बदलू शकतात. सहभागी होण्यापूर्वी प्रत्येक ऑफरसाठी समर्पक अटींचे पुनरावलोकन करणे उचित आहे.',
      disclaimer: {
        title: 'अस्वीकरण',
        points: [
          'अॅप तुमच्या डिव्हाइसवर गेल्या 30 दिवसांत स्थापित केलेले नसावे.',
          'सर्व चरण पूर्ण झाल्यानंतरच बक्षीस दिले जाईल.',
          'विज्ञापनदाराच्या पुष्टीकरणानंतरच बक्षीस दिले जाईल.',
          'विज्ञापनदारास पुष्टीकरणासाठी 24 तास लागू शकतात.',
          'व्हीपीएनचा वापर करून कोणत्याही फसवणूक कृतीमुळे खाते बंद होईल.',
        ],
      },
      details: {
        steps: 'सूचना',
        support: 'समस्यांना तोंड देत आहे?',
        reach: 'आमच्यापर्यंत पोहोचा',
        terms: 'अटी व शर्ती',
        read: 'पुढे वाचा',
        btnactions: {
          open: 'ॲप उघडा',
          get: 'मिळवा',
        },
        status: {
          chips: {
            expired: 'कालबाह्य',
            useapp: 'ॲप वापरण्याची प्रतीक्षा करत आहे',
            waiting: 'वाट पाहत आहे',
            ongoing: 'आता चालू आहे',
            unlock: 'अनलॉक होण्याची प्रतीक्षा करत आहे',
            completed: 'पूर्ण झाले',
          },
          expired: {
            title: 'ही ऑफर कालबाह्य झाली आहे!',
            description:
              'ही ऑफर आता उपलब्ध नाही असे दिसते. तुमचे पुढील रिवॉर्ड मिळवण्यासाठी आणखी ऑफर एक्सप्लोर करा!',
          },
          cpl: {
            title: 'पूर्ण होण्याची वेळ',
          },
          ongoing: {
            title: 'तुमचे बक्षीस मिळण्याच्या मार्गावर आहे!',
            description:
              'काहीवेळा जाहिरातदारांना तुमच्या कृतीची पुष्टी करण्यासाठी 3 दिवस लागतात. अधिक पुरस्कारांसाठी इतर ऑफर पहा!',
          },
          retention: {
            unlock: 'पुढील पुरस्कार अनलॉक करण्याची वेळ',
            ongoing: 'ॲप उघडा आणि एक्सप्लोर करा!',
            description:
              'तुम्ही ॲपचा जितका जास्त वापर कराल तितकी बक्षिसे मिळण्याची खात्री जास्त.',
          },
          completed: {
            title: 'अभिनंदन!',
            description:
              'ही ऑफर पूर्ण केल्याबद्दल पुरस्कृत. तुमचे पुढील रिवॉर्ड मिळवण्यासाठी आणखी ऑफर एक्सप्लोर करा!',
          },
        },
      },
      support: [
        {
          question: 'चुकीचे पुरस्कार मूल्य प्राप्त झाले',
          answer:
            'तुम्ही वरील ऑफरसाठी सपोर्ट क्वेरी करू शकता. तुम्ही सुरू केलेल्या ऑफरमध्ये काही समस्या असल्यास कृपया आम्हाला कळवा',
          action: 'आमच्याशी संपर्क साधा',
        },
        {
          question: 'ऑफरसाठी बक्षीस मिळाले नाही',
          answer:
            'तुम्ही वरील ऑफरसाठी सपोर्ट क्वेरी करू शकता. तुम्ही सुरू केलेल्या ऑफरमध्ये काही समस्या असल्यास कृपया आम्हाला कळवा',
          action: 'आमच्याशी संपर्क साधा',
        },
        {
          question:
            'मी ऑफरमध्ये नमूद केलेल्या सर्व पायऱ्या पूर्ण केल्या आहेत, परंतु माझी ऑफर अद्याप चालू आहे. आता मी काय करू?',
          answer: (
            <>
              <ul className="pl-4 mt-1 list-disc">
                <li>
                  आम्ही तुमची पूर्णता पडताळत असताना ही ऑफर चालू असलेल्या
                  ऑफरमध्ये देखील दर्शविली जाईल.
                </li>
                <li>
                  कृपया रिवॉर्डसाठी पात्र होण्यासाठी तुम्ही किमान 5 मिनिटांसाठी
                  ॲपचा वापर केल्याची खात्री करा.
                </li>
              </ul>
            </>
          ),
        },
      ],
    },
    help: {
      title: 'सतत विचारले जाणारे प्रश्न',
      header: {
        title: (
          <>
            बद्दल सांगा <br className="portrait:hidden" /> तुम्ही ज्या समस्यांना
            तोंड देत आहात
          </>
        ),
        description: 'उत्तरासाठी आदर्श वेळ 24 तासांपेक्षा कमी आहे',
      },
      support: {
        title: 'समस्येला तोंड देत आहे? आमच्याशी बोला',
        cta: 'आमच्याशी संपर्क साधा',
      },
      items: [
        {
          question: 'मी ऑफरचा लाभ कसा घेऊ शकतो?',
          answer: (
            <>
              ऑफरचा लाभ घेण्यासाठी या चरणांचे अनुसरण करा:
              <ul className="pl-4 mt-1 list-disc">
                <li>ऑफर तपशील पाहण्यासाठी ऑफरवर क्लिक करा.</li>
                <li>
                  सर्व पायऱ्या काळजीपूर्वक वाचा आणि सर्व पायऱ्या एकामागून एक
                  करा.
                </li>
                <li>
                  कार्ये पूर्ण झाल्याची पडताळणी केल्यावर बक्षिसे दिली जातील.
                </li>
              </ul>
            </>
          ),
        },
        {
          question: 'मला बक्षिसे कधी मिळतील?',
          answer:
            'तुम्ही ऑफरमध्ये नमूद केलेल्या सर्व पायऱ्या पूर्ण केल्याचे आम्ही सत्यापित केल्यावर तुम्हाला बक्षिसे मिळतील.',
        },
        {
          question: 'चालू असलेली ऑफर म्हणजे काय?',
          answer:
            'चालू असलेली ऑफर म्हणजे तुम्ही अर्धवट पूर्ण केलेली ऑफर, म्हणजे, जिथे तुम्ही सर्व पायऱ्या पूर्ण केल्या नाहीत किंवा आम्ही तुमच्या पूर्णतेची पडताळणी करण्याच्या प्रक्रियेत आहोत.',
        },
        {
          question:
            'मी ऑफरमध्ये नमूद केलेल्या सर्व पायऱ्या पूर्ण केल्या आहेत, परंतु माझी ऑफर अद्याप चालू आहे. आता मी काय करू?',
          answer: (
            <>
              <ul className="pl-4 mt-1 list-disc">
                <li>
                  आम्ही तुमची पूर्णता पडताळत असताना ही ऑफर चालू असलेल्या
                  ऑफरमध्ये देखील दर्शविली जाईल.
                </li>
                <li>
                  कृपया रिवॉर्डसाठी पात्र होण्यासाठी तुम्ही किमान 5 मिनिटांसाठी
                  ॲपचा वापर केल्याची खात्री करा.
                </li>
              </ul>
            </>
          ),
        },
        {
          question: 'मला पुरस्कार कसे मिळतील?',
          answer:
            'ऑफर यशस्वीरीत्या पूर्ण केल्यावर रिवॉर्ड आपोआप तुमच्या वॉलेटमध्ये जोडले जातील.',
        },
      ],
    },
    refer: {
      title: 'संदर्भ घ्या आणि कमवा',
      redirect: 'पुनर्निर्देशित करत आहे...',
      view: 'संदर्भ पहा',
      refercta: 'आता मित्राचा संदर्भ घ्या',
      share: 'संदर्भ कोड',
      howto: {
        title: 'हे कसे कार्य करते',
        items: [
          {
            title: 'तुमच्या मित्रांना आमंत्रित करा',
            description: 'फक्त तुमची लिंक शेअर करा',
          },
          {
            title: 'सुरवात',
            description: 'जेव्हा तुमचा मित्र 3 ऑफर पूर्ण करतो',
          },
          {
            title: `3 ऑफरवर ते जे कमवतात त्यातील ${REFERRAL_WINNING_PERCENTANGE}% तुम्ही कमावता`,
            description: 'तुमचा मित्र पहिल्या 3 ऑफरवर 5% अतिरिक्त कमावतो',
          },
          {
            title: 'तुम्ही अनेक मित्रांना रेफर करू शकता',
            description: 'तुमचे पाकीट भरलेले असताना शांत बसा आणि आराम करा',
          },
        ],
      },
      list: {
        title: 'तुमचे रेफरल्स',
        description:
          'तुमच्या रेफरल्सने तुम्हाला रेफरल कॉइन्स मिळण्यासाठी टप्पे गाठले पाहिजेत.',
        offerscompleted: 'ऑफर पूर्ण झाल्या',
      },
    },
    contest: {
      tabs: {
        ongoing: 'आता चालू आहे',
        older: 'जुने',
        stats: 'तुमची आकडेवारी',
        leaderboard: 'लीडरबोर्ड',
        rules: 'नियम',
      },
      leaderboard: {
        loading: 'लोड करत आहे...',
        rank: 'तुमची रँक',
        prize: 'पारितोषिक',
        update: 'येथे अंतिम अद्यतनित:',
        offertype: {
          offer: 'ऑफर',
          refer: 'रेफरल्स',
        },
      },
      modal: {
        joined: 'स्पर्धेत सामील झाले',
        offertype: {
          offer: (
            <>
              जिंकायला सुरुवात करा,
              <br />
              पूर्ण ऑफर
            </>
          ),
          refer: (
            <>
              जिंकायला सुरुवात करा,
              <br />
              संदर्भ देणे सुरू करा
            </>
          ),
        },
        cta: 'कमाई सुरू करा',
      },
      status: {
        title: 'स्पर्धा',
        close: 'बंद',
        ends: 'मध्ये संपतो',
        starts: 'मध्ये सुरू होते',
        headers: {
          completed: 'ही स्पर्धा संपली आहे.',
          refer: 'रेफरिंग मित्रांसाठी बक्षिसे मिळवा.',
          offer: 'जास्तीत जास्त ऑफर पूर्ण करण्यासाठी बक्षिसे मिळवा.',
        },
      },
      join: 'आताच सामील व्हा',
      freejoin: 'मोफत',
      minimumBalance: ({ value, currency }) => (
        <>
          सामील होण्यासाठी तुमच्याकडे {value} {currency} असणे आवश्यक आहे
        </>
      ),
      insufficientBalance: 'अपुरी शिल्लक',
      rankcard: {
        rank: 'तुमची रँक',
        reward: 'तुमचे बक्षीस',
        top: 'टॉपवर राहण्यासाठी ऑफर पूर्ण करत रहा',
        climb: 'लीडरबोर्डवर वर चढण्यासाठी ऑफर पूर्ण करत रहा',
        cta: 'ऑफर्स वर जा',
      },
      refercard: {
        title: 'संदर्भ घ्या आणि द्वारे कमवा',
        invite: 'रेफरल कोडद्वारे आमंत्रित करा',
        copy: 'कॉपी करा',
      },
      contestcard: {
        register: 'नोंदणीकृत',
        join: {
          profilejoined:
            'तुम्ही स्पर्धेत सामील झाला आहात, टास्क करून कमाई सुरू करा!',
          joined: 'स्पर्धेत सामील झाले',
          cta: 'आता सामील व्हा',
        },
        rank: 'तुमची रँक',
        reward: 'तुमचे बक्षीस',
        entry: 'प्रवेश',
        free: 'फुकट',
        maxreward: 'कमाल बक्षीस',
        details: 'तपशील पहा',
      },
      rewardcard: {
        title: 'प्रतियोगिता उपहार',
        rank: 'श्रेणी',
        reward: 'उपहार',
      },
      errorboundary: {
        header: {
          title: 'अरेरे!',
          description: 'काहीतरी चूक झाली.',
        },
        description:
          'गैरसोयीबद्दल आम्ही दिलगीर आहोत. पुन्हा प्रयत्न करण्यासाठी ॲप बंद करा आणि पुन्हा उघडा. समस्या कायम राहिल्यास, कृपया समस्येचा अहवाल द्या.',
        feedbackcta: 'अभिप्राय कळवा',
        retrycta: 'पुन्हा प्रयत्न करा',
      },
    },
    profile: {
      title: 'प्रोफाइल',
      earning: 'पासून कमाई',
      stats: {
        title: 'आकडेवारी',
        totalearned: 'नाणी मिळविली',
        redeem: 'रिडीम केलेली रक्कम',
        offers: 'ऑफर प्रयत्न केला',
        refer: 'रेफरल्स',
      },
    },
    wallet: {
      title: 'वॉलेट बॅलन्स',
      redeem: 'आता रिडीम करा',
      earning: 'कमाईचा इतिहास',
      transaction: 'व्यवहार इतिहास',
    },
    redeem: {
      store: {
        title: 'स्टोअर रिडीम करा',
        maxredemption: 'अनुमत रिडीम्शनची कमाल संख्या गाठली आहे.',
        noredeemoption: (
          <>
            <p>कोणतेही रिडीम पर्याय सध्या उपलब्ध नाहीत</p>
            <p>
              कृपया नंतर पुन्हा प्रयत्न करा किंवा आमच्या समर्थन कार्यसंघाशी
              संपर्क साधा.
            </p>
          </>
        ),
      },
      pack: {
        nodata: 'एकदा ते उपलब्ध झाल्यावर तुम्हाला येथे पॅक दिसतील.',
      },
      payout: {
        form: {
          title: 'रिडीम',
          placeholder: 'तुमचा पेमेंट पत्ता प्रविष्ट करा',
          noemail:
            'या पॅकसाठी तुमच्या प्रोफाइलमध्ये ईमेल पत्ता सेट करणे आवश्यक आहे.',
          cta: 'पुढे जा',
          confirmdialog: {
            title: 'खात्री आहे का?',
            address: 'पेमेंट पत्ता:',
            amount: 'रक्कम:',
            confirm: 'पुष्टी',
            cancel: 'रद्द करा',
          },
        },
        status: {
          note: 'नोंद:',
          reason: 'कारण:',
          rateus: 'आम्हाला Play Store वर रेट करा',
          processing: {
            title: 'पेमेंट प्रोसेसिंग',
            description:
              'पेमेंट साधारणपणे ६ तासांच्या आत तुमच्या खात्यात जमा होते. तोपर्यंत तुमची नाणी आमच्याकडे सुरक्षित आहेत.',
          },
          processed: 'पेमेंट यशस्वी',
          failed: 'पेमेंट अयशस्वी',
          stillprocess: {
            title: 'पेमेंट अजूनही प्रक्रिया करत आहे',
            description:
              'पेमेंट विनंती पाठवली आहे. अयशस्वी झाल्यास वॉलेटमध्ये परतावा जारी केला जाईल.',
          },
        },
        crypto: {
          download: {
            title: 'लाइटनिंग पत्ता नाही?',
            cta: 'ZBD येथे डाउनलोड करा!',
          },
          info: {
            title: 'ZBD ॲपमध्ये विजेचा पत्ता कसा शोधायचा?',
            steps: [
              {
                title: 'प्लेस्टोअरवरून ZBD ॲप इंस्टॉल करा',
                cta: 'ZBD स्थापित करा',
              },
              {
                title: 'साइड मेनू प्रोफाइल चिन्हावर क्लिक करा',
              },
              {
                title: 'वापरकर्तानावावर क्लिक करा',
                description: 'हे तुमच्या क्लिपबोर्डवर विजेचा पत्ता कॉपी करेल',
              },
            ],
          },
        },
      },
    },
    spin: {
      title: 'स्पिन आणि विन',
      description:
        'भविष्याचे चाक फिरवण्यासाठी भरतकॉइनने भरलेली बॅग जिंकण्याची संधी मिळवा.',
      timer: {
        wait: 'साठी प्रतीक्षा',
        end: 'आपल्या नशिबाची चाचणी घेण्यासाठी.',
      },
      cta: 'फिरकी',
      completeoffer: {
        cta: 'अनलॉक करण्यासाठी एक कार्य पूर्ण करा',
        description:
          'स्पिन अनलॉक करण्यासाठी तुम्हाला एक ऑफर पूर्ण करावी लागेल!',
      },
      modal: {
        oops: 'अरेरे!',
        better: 'पुढच्या वेळेसाठी शुभेच्छा',
        congrats: 'अभिनंदन!',
        won: 'तू जिंकला आहेस',
      },
      again: {
        title: 'आणखी जिंकण्यासाठी पुन्हा या',
        cta: 'इतर कार्ये एक्सप्लोर करा',
      },
    },
    empty: {
      available: 'माहिती उपलब्ध नाही',
      data: 'माहिती उपलब्ध नाही',
      found: 'माहिती आढळली नाही',
      referrals: 'अद्याप कोणतेही संदर्भ नाहीत',
      contest: {
        ongoing: 'चालू असलेल्या स्पर्धा नाहीत',
        old: 'जुन्या स्पर्धा नाहीत',
      },
      offers: {
        ongoing: 'कोणत्याही चालू ऑफर नाहीत',
        completed: 'पूर्ण झालेल्या ऑफर नाहीत',
        found: 'कोणत्याही ऑफर आढळल्या नाहीत',
        resetFilterCta: 'फिल्टर रीसेट करा',
      },
      internet: 'सक्रिय इंटरनेट कनेक्शन नाही!',
    },
    toast: {
      refer: {
        copy: 'रेफरल कोड कॉपी केला',
        emptycode: 'कृपया रेफरल कोड टाका',
        notExist: 'रेफरल अस्तित्वात नाही',
      },
      failed: 'शेअर करण्यात अयशस्वी, कृपया पुन्हा प्रयत्न करा',
      redeem: {
        maxredemption:
          'अनुमत रिडीम्शनची कमाल संख्या गाठली आहे. कृपया पुन्हा प्रयत्न करा.',
        pack: 'हा पॅक सध्या उपलब्ध नाही',
        validaddress: 'कृपया वैध पेमेंट पत्ता प्रविष्ट करा',
        invalid: 'अवैध ईमेल आयडी',
      },
      loginfailed: 'Google लॉगिन अयशस्वी',
    },
    dialog: {
      offline: {
        title: 'अरेरे, इंटरनेट कनेक्शन नाही',
        description:
          'उपलब्ध ऑफरमध्ये प्रवेश करण्यासाठी कृपया तुमचा WiFi किंवा मोबाइल डेटा चालू करा.',
      },
      error: {
        title: 'काही गलत झालं आहे',
        description:
          'हे तुमचं नाही, हे आम्ही! <br /> चिंता करू नका, पुन्हा प्रयत्न करा.',
        cta: 'पुन्हा प्रयत्न करा',
      },
      notfound: {
        title: '404 | पृष्ठ सापडले नाही',
        description: 'आपण शोधत असलेले पृष्ठ सापडले नाही.',
        cta: 'ऑफर एक्सप्लोर करा',
      },
      enableUsagePermission: {
        title: 'वापर प्रवेश सक्षम करा',
        description:
          'आता या ऑफरमधून आश्चर्यकारक बक्षिसे मिळवण्यासाठी वापर प्रवेश सक्षम करा!',
        cta: 'सक्षम करा',
      },
      confirmAlert: {
        cta: {
          confirm: 'पुष्टी करा',
          cancel: 'रद्द करा',
        },
      },
      banned: {
        heading: 'आपण CashPlay वापरण्यापासून बंदी घातली आहे.',
        description:
          'आपल्याला वाटत असल्यास ही चूक आहे, कृपया समर्थनाशी संपर्क साधा',
      },
      editProfile: {
        name: 'नाव',
      },
      fraud: {
        vpn: {
          title: 'अरे, आम्ही VPN शोधले आहे',
          desc: 'सुनिश्चित करण्यासाठी की तुम्हाला एक सुचारू आणि सुरक्षित अनुभव मिळेल, तुम्हाला VPN बंद करावे लागेल.',
        },
        rooted: {
          title: 'अरे, आम्ही एक रूटेड डिव्हाइस शोधले आहे',
          desc: 'सुनिश्चित करण्यासाठी की तुम्हाला एक सुचारू आणि सुरक्षित अनुभव मिळेल, तुम्हाला एक नॉन-रूटेड डिव्हाइस वापरावे लागेल.',
        },
        modApp: {
          title: 'अरे, आम्ही शोधले की तुम्ही एक मॉड अ‍ॅप वापरत आहात',
          desc: 'सुनिश्चित करण्यासाठी की तुम्हाला एक सुचारू आणि सुरक्षित अनुभव मिळेल, तुम्हाला योग्य अ‍ॅप डाउनलोड करावे लागेल.',
        },
        developerOptions: {
          title: 'अरे, आम्ही शोधले की डेव्हलपर पर्याय सुरू आहेत',
          desc: 'सुनिश्चित करण्यासाठी की तुम्हाला एक सुचारू आणि सुरक्षित अनुभव मिळेल, तुम्हाला डेव्हलपर पर्याय बंद करावे लागतील.',
        },
        emulator: {
          title: 'अरे, आम्ही एक एम्युलेटर शोधले आहे',
          desc: 'सुनिश्चित करण्यासाठी की तुम्हाला एक सुचारू आणि सुरक्षित अनुभव मिळेल, कृपया ते सामान्य अ‍ॅपमध्ये वापरा.',
        },
        blacklistedApp: fraud => ({
          title: 'इशारा! संशयास्पद अ‍ॅप शोधले',
          desc: (
            <div>
              <p className="mb-4">
                {`कृपया अ‍ॅप वापरण्यासाठी खाली सूचीबद्ध अ‍ॅप्स अनइंस्टॉल करा`}
              </p>
              {fraud?.data?.map((d, index) => (
                <p key={index} className="my-1 text-color text-md ">
                  {d}
                </p>
              ))}
            </div>
          ),
        }),
        clone: {
          title: 'अरे, आम्ही शोधले की तुमचे डिव्हाइस क्लोन केले आहे',
          desc: 'सुनिश्चित करण्यासाठी की तुम्हाला एक सुचारू आणि सुरक्षित अनुभव मिळेल, तुम्हाला नॉन-क्लोन डिव्हाइस वापरावे लागेल.',
        },
      },
    },
    forceUpdate: {
      title: `नमस्कार! आम्ही आमच्या अॅपसाठी एक नवीन अपडेट जारी केला आहे ज्यामध्ये नवीन फीचर्स, सुधारणा आणि बग फिक्सेस आहेत. कृपया ते त्वरित इंस्टॉल करा आणि उत्तम अनुभवाचा आनंद घ्या. धन्यवाद!`,
      cta: 'अपडेट करा',
    },
  },
  BAHASA_INDONESIA: {
    login: {
      title: 'Selamat datang di CashPlay',
      cta: 'Masuk dengan Google',
      phoneLogin: {
        title: 'Login dengan Nomor Telepon',
        enterPhone: 'Masukkan Nomor Telepon',
        phoneDescription:
          'Silakan masukkan nomor telepon Anda untuk menerima OTP.',
        getOtp: 'Dapatkan OTP',
        enterOtp: 'Masukkan OTP',
        otpDescription: 'Silakan masukkan OTP yang dikirim ke ponsel Anda.',
        submit: 'Kirim',
        retryOtp: 'Coba lagi OTP dalam {timer} detik',
        resendOtp: 'Kirim ulang OTP',
      },
    },
    signup: {
      referralLabel: 'Kode Redeem',
      referralPlaceholder: 'Masukkan Kode Referral',
      nameLabel: 'Nama Anda',
      namePlaceholder: 'Masukkan Nama Lengkap Anda',
      submit: 'Kirim',
      skip: 'Lewati',
    },
    home: {
      notification: {
        title: 'Aktifkan izin notifikasi',
        description:
          'Aktifkan notifikasi untuk mendapatkan pembaruan langsung tentang perjalanan penghasilan Anda.',
        btn: 'Aktifkan',
      },
      sdk: {
        play: 'Main & Dapatkan',
        survey: 'Imbalan Survei',
        spin: 'Putar & Menang',
        games: 'Permainan',
      },
      filters: {
        title: 'Saring',
        selected: 'terpilih',
        type: 'Jenis Penawaran',
        category: 'Kategori Penawaran',
        applyAction: 'Terapkan',
        clearAll: 'Bersihkan semua',
      },
      tags: {
        SINGLE_STEP: 'Langkah Tunggal',
        MULTI_REWARD: 'Hadiah Ganda',
        GAMING: 'Permainan',
        FINANCE: 'Keuangan',
        SURVEY: 'Survei',
        DEPOSIT: 'Butuh Deposit',
        NEW: 'Baru',
      },
      sort: {
        title: 'Urutkan',
        default: 'Default (Relevansi)',
        ttfp: 'Waktu',
        price: 'Hadiah',
        highToLow: 'Tinggi ke Rendah',
        lowToHigh: 'Rendah ke Tinggi',
      },
    },
    nav: {
      wallet: 'Saldo Dompet',
      home: 'Beranda',
      offers: 'Penawaran',
      refer: 'Referensikan',
      contest: 'Kontes',
      settings: 'Pengaturan',
      back: 'Kembali',
      logout: 'Keluar',
      logoutmodal: 'Apakah Anda yakin ingin keluar',
    },
    dailycheckin: {
      notclaimed: {
        header: {
          title: 'Selamat',
          description: 'Datang setiap hari untuk mendapatkan hadiah menarik.',
        },
        footer: {
          description:
            'Hadiah Anda siap untuk diklaim. Klik tombol di bawah untuk mengklaim hadiah Anda.',
          cta: 'Klaim',
          offercta: 'Selesaikan Satu Penawaran untuk Klaim',
        },
      },
      claiming: {
        congrats: 'Selamat!',
        reward: 'Anda mendapat hadiah',
        success: 'Anda telah berhasil mengklaim',
      },
      claimed: {
        reward: 'Hadiah Anda',
        nextreward: 'Hadiah berikutnya dalam',
        day: 'Hari',
      },
    },
    settings: {
      title: 'Pengaturan',
      profile: 'Profil',
      help: 'Bantuan',
      tc: 'Syarat & Ketentuan',
      privacy: 'Privasi',
      contact: 'Hubungi Kami',
      language: 'Bahasa',
      description:
        'Silakan gunakan tombol di bawah ini untuk menghubungi kami melalui email',
    },
    offers: {
      allOfferHome: 'Semua Penawaran',
      all: 'Semua Penawaran',
      ongoing: 'Sedang Berlangsung',
      availed: 'Dimanfaatkan',
      expired: 'Kedaluwarsa',
      supporthead: 'Dukungan',
      avgTime: 'Waktu Rata-rata Hadiah',
      comment: {
        error: 'Silakan masukkan setidaknya 30 karakter',
        submitBtn: 'Kirim',
        inputLabel: 'Umpan balik',
        feedback: 'Terima kasih atas masukan Anda',
      },
      voteErrors: {
        5001: 'Tidak dapat memilih sebelum penawaran dimulai',
        5002: 'Jumlah suara maksimum telah tercapai',
        5003: 'Batas waktu pemungutan suara telah terlampaui',
        5005: 'Umpan balik wajib untuk suara turun',
        5006: 'Jumlah karakter dalam Umpan Balik melebihi batas',
      },
      type: {
        CPI: 'Dapatkan Sekarang',
        CPA: 'Selesaikan Sekarang',
        CPR: 'Daftar Sekarang',
        'APK-INSTALL': 'Dapatkan Sekarang',
        'APK-REGISTER': 'Daftar Sekarang',
        CPL: 'Selesaikan Sekarang',
        default: 'Selesaikan Sekarang',
      },
      supportoffercard: {
        title: 'Estimasi waktu untuk hadiah: 3 hari',
        description:
          'Kadang-kadang pengiklan memerlukan waktu hingga 3 hari untuk memverifikasi hadiah Anda.',
      },
      nooffer: {
        title: 'Maaf, kami tidak dapat menemukan penawaran yang Anda cari.',
        cta: 'Jelajahi Lebih Banyak Penawaran',
        ongoing: 'Tidak ada penawaran sedang berlangsung',
        completed: 'Tidak ada penawaran yang selesai',
        nooffer: 'Tidak ada penawaran',
      },
      offerNotAvailable: {
        title:
          'Kami mohon maaf, tetapi penawaran ini saat ini tidak tersedia. Silakan jelajahi penawaran lainnya.',
        cta: 'Jelajahi Lebih Banyak Penawaran',
      },
      termscondition:
        'Dengan mengambil bagian dalam setiap penawaran atau acara, Anda menyetujui syarat dan ketentuan berikut. Jika hadiah tidak diberikan karena keadaan yang tidak dapat diatribusikan kepada kami, hadiah lebih lanjut akan hangus. Harap dicatat bahwa kelayakan untuk mendapatkan hadiah mensyaratkan pembuatan akun baru; akun yang sudah ada tidak memenuhi syarat untuk hadiah tertentu ini. Hadiah akan diberikan secara eksklusif setelah menyelesaikan level-level yang ditentukan secara eksplisit dalam penawaran untuk aplikasi yang ditunjuk. Selain itu, penawaran multi-hadiah ini tidak dapat digabungkan dengan penawaran bersama yang berkaitan dengan aplikasi yang sama. Untuk mengakses beberapa hadiah untuk menyelesaikan level yang ditentukan, harap klik tombol di bawah dan mulai aplikasinya. Penting untuk menyadari bahwa syarat dan ketentuan ini berlaku secara universal untuk semua penawaran dan acara; namun, detail tertentu dapat bervariasi sesuai dengan promosi individu. Disarankan untuk meninjau syarat yang relevan untuk setiap penawaran sebelum berpartisipasi.',
      disclaimer: {
        title: 'Penafian',
        points: [
          'Aplikasi tidak boleh diinstal di perangkat Anda dalam 30 hari terakhir.',
          'Hadiah akan diberikan setelah menyelesaikan semua langkah.',
          'Hadiah akan diberikan setelah konfirmasi dari pengiklan.',
          'Pengiklan mungkin memerlukan waktu hingga 24 jam untuk mengonfirmasi hadiah.',
          'Setiap aktivitas penipuan, termasuk penggunaan VPN, akan mengakibatkan larangan akun.',
        ],
      },
      details: {
        steps: 'Petunjuk',
        support: 'Menghadapi masalah?',
        reach: 'Hubungi kami',
        terms: 'Syarat & Ketentuan',
        read: 'Baca lebih lanjut',
        btnactions: {
          open: 'Buka Aplikasi',
          get: 'Dapatkan',
        },
        status: {
          chips: {
            expired: 'Kedaluwarsa',
            useapp: 'Menunggu Menggunakan Aplikasi',
            waiting: 'Menunggu',
            ongoing: 'Berlangsung',
            unlock: 'Menunggu Membuka',
            completed: 'Selesai',
          },
          expired: {
            title: 'Penawaran ini sudah kedaluwarsa!',
            description:
              'Sepertinya penawaran ini tidak lagi tersedia. Jelajahi lebih banyak penawaran untuk mendapatkan hadiah Anda selanjutnya!',
          },
          cpl: {
            title: 'Waktu untuk menyelesaikan',
          },
          ongoing: {
            title: 'Hadiah Anda sedang dalam perjalanan!',
            description:
              'Kadang-kadang pengiklan memerlukan waktu hingga 3 hari untuk mengkonfirmasi tindakan Anda. Lihat penawaran lain untuk mendapatkan lebih banyak hadiah!',
          },
          retention: {
            unlock: 'Waktu untuk Membuka Hadiah Berikutnya',
            ongoing: 'Buka dan Jelajahi Aplikasi!',
            description:
              'Semakin sering Anda menggunakan aplikasi, semakin besar jaminan untuk menerima hadiah.',
          },
          completed: {
            title: 'Selamat!',
            description:
              'Diberi hadiah karena menyelesaikan penawaran ini. Jelajahi lebih banyak penawaran untuk mendapatkan hadiah Anda selanjutnya!',
          },
        },
      },
      support: [
        {
          question: 'Nilai hadiah yang tidak benar diterima',
          answer:
            'Anda dapat mengajukan pertanyaan dukungan untuk penawaran di atas. Beri tahu kami jika ada masalah dengan penawaran yang telah Anda mulai',
          action: 'Hubungi kami',
        },
        {
          question: 'Tidak menerima hadiah untuk penawaran',
          answer:
            'Anda dapat mengajukan pertanyaan dukungan untuk penawaran di atas. Beri tahu kami jika ada masalah dengan penawaran yang telah Anda mulai',
          action: 'Hubungi kami',
        },
        {
          question:
            'Saya telah menyelesaikan semua langkah yang disebutkan dalam penawaran, tetapi penawaran saya masih berlangsung. Apa yang harus saya lakukan sekarang?',
          answer:
            'Penawaran juga akan ditampilkan dalam penawaran yang sedang berlangsung saat kami memverifikasi penyelesaian Anda.\nPastikan Anda telah menggunakan aplikasi setidaknya 5 menit untuk memenuhi syarat untuk hadiah.',
        },
      ],
    },
    help: {
      title: 'Pertanyaan yang Sering Diajukan',
      header: {
        title: 'Beritahu kami tentang Masalah yang Anda Hadapi',
        description: 'Waktu ideal untuk balasan kurang dari 24 jam',
      },
      support: {
        title: 'Menghadapi masalah? Bicarakan dengan kami',
        cta: 'Hubungi Kami',
      },
      items: [
        {
          question: 'Bagaimana cara saya memperoleh penawaran?',
          answer:
            'Ikuti langkah-langkah ini untuk memperoleh penawaran:\n1. Klik penawaran untuk melihat detail penawaran.\n2. Baca semua langkah dengan cermat dan lakukan semua langkah satu per satu.\n3. Hadiah akan diberikan setelah kami memverifikasi bahwa tugas-tugas telah selesai.',
        },
        {
          question: 'Kapan saya akan menerima hadiah?',
          answer:
            'Anda akan menerima hadiah setelah kami memverifikasi bahwa Anda telah menyelesaikan semua langkah yang disebutkan dalam penawaran.',
        },
        {
          question: 'Apa itu penawaran yang sedang berlangsung?',
          answer:
            'Penawaran yang sedang berlangsung adalah penawaran yang telah Anda selesaikan sebagian, yaitu di mana Anda belum menyelesaikan semua langkah atau kami sedang dalam proses memverifikasi penyelesaian Anda.',
        },
        {
          question:
            'Saya telah menyelesaikan semua langkah yang disebutkan dalam penawaran, tetapi penawaran saya masih berlangsung. Apa yang harus saya lakukan sekarang?',
          answer:
            'Penawaran juga akan ditampilkan dalam penawaran yang sedang berlangsung saat kami memverifikasi penyelesaian Anda.\nPastikan Anda telah menggunakan aplikasi setidaknya 5 menit untuk memenuhi syarat untuk hadiah.',
        },
        {
          question: 'Bagaimana cara saya menerima hadiah?',
          answer:
            'Hadiah akan secara otomatis ditambahkan ke dompet Anda setelah menyelesaikan penawaran dengan sukses.',
        },
      ],
    },
    refer: {
      title: 'Referensikan & Dapatkan',
      redirect: 'Mengalihkan...',
      view: 'Lihat Referral',
      refercta: 'Referensikan teman sekarang',
      share: 'Kode Referensi',
      howto: {
        title: 'Bagaimana Cara Kerjanya',
        items: [
          {
            title: 'Undang teman Anda',
            description: 'Cukup bagikan tautan Anda',
          },
          {
            title: 'Mereka memulai',
            description: 'Ketika teman Anda menyelesaikan 3 penawaran',
          },
          {
            title: `Anda mendapatkan ${REFERRAL_WINNING_PERCENTANGE}% dari apa yang mereka dapatkan dari 3 penawaran`,
            description:
              'Teman Anda mendapatkan 5% ekstra pada 3 penawaran pertama',
          },
          {
            title: 'Anda dapat merujuk banyak teman',
            description: 'Duduklah dan santai, sementara dompet Anda terisi',
          },
        ],
      },
      list: {
        title: 'Referral Anda',
        description:
          'Referral Anda harus menyelesaikan serangkaian milestone agar Anda menerima koin referral.',
        offerscompleted: 'Penawaran Selesai',
      },
    },
    contest: {
      tabs: {
        ongoing: 'Sedang Berlangsung',
        older: 'Lama',
        stats: 'Statistik Anda',
        leaderboard: 'Papan Peringkat',
        rules: 'Aturan',
      },
      leaderboard: {
        loading: 'Memuat...',
        rank: 'Peringkat Anda',
        prize: 'Hadiah',
        update: 'Terakhir Diperbarui Pada:',
        offertype: {
          offer: 'Penawaran',
          refer: 'Referral',
        },
      },
      modal: {
        joined: 'Kontes Dimulai',
        offertype: {
          offer: 'Mulai Menang, Selesaikan Penawaran',
          refer: 'Mulai Menang, Mulai Merujuk',
        },
        cta: 'Mulai Mencari',
      },
      status: {
        title: 'Kontes',
        close: 'Tutup',
        ends: 'Berakhir dalam',
        starts: 'Dimulai dalam',
        headers: {
          completed: 'Kontes ini sudah berakhir.',
          refer: 'Dapatkan hadiah untuk merujuk teman.',
          offer: 'Dapatkan hadiah untuk menyelesaikan penawaran maksimum.',
        },
      },
      join: 'Bergabung sekarang untuk',
      freejoin: 'Gratis',
      minimumBalance: ({ value, currency }) => (
        <>
          Anda harus memiliki {value} {currency} untuk bergabung
        </>
      ),
      insufficientBalance: 'Saldo tidak mencukupi',
      rankcard: {
        rank: 'Peringkat Anda',
        reward: 'Hadiah Anda',
        top: 'Terus selesaikan penawaran untuk tetap di puncak',
        climb:
          'Terus selesaikan penawaran untuk naik peringkat di papan peringkat',
        cta: 'Pergi ke Penawaran',
      },
      refercard: {
        title: 'Referensikan dan dapatkan melalui',
        invite: 'Undang melalui Kode Referensi',
        top: 'Terus lakukan penawaran untuk tetap berada di papan atas',
        climb: 'Terus lakukan penawaran untuk naik di papan peringkat',
        copy: 'Salin',
      },
      contestcard: {
        register: 'Terdaftar',
        join: {
          profilejoined:
            'Anda telah bergabung dengan kontes, Mulai menghasilkan dengan melakukan tugas!',
          joined: 'Kontes Dimulai',
          cta: 'Bergabung sekarang',
        },
        rank: 'Peringkat Anda',
        reward: 'Hadiah Anda',
        entry: 'Entri',
        free: 'GRATIS',
        maxreward: 'Hadiah Maksimum',
        details: 'Lihat Detail',
      },
      rewardcard: {
        title: 'Hadiah Kontes',
        rank: 'Peringkat',
        reward: 'Hadiah',
      },
      errorboundary: {
        header: {
          title: 'Ups!',
          description: 'Ada yang salah.',
        },
        description:
          'Maaf atas ketidaknyamanannya. tutup dan buka kembali aplikasi untuk mencoba lagi. Jika masalahnya masih berlanjut, laporkan masalah tersebut.',
        feedbackcta: 'Laporkan masalah',
        retrycta: 'Coba lagi',
      },
    },
    profile: {
      title: 'Profil',
      earning: 'Menghasilkan sejak',
      stats: {
        title: 'Statistik',
        totalearned: 'Koin yang Didapat',
        redeem: 'Jumlah Ditebus',
        offers: 'Penawaran yang Dicoba',
        refer: 'Referral',
      },
    },
    wallet: {
      title: 'Saldo Dompet',
      redeem: 'Tebus Sekarang',
      earning: 'Riwayat Penghasilan',
      transaction: 'Riwayat Transaksi',
    },
    redeem: {
      store: {
        title: 'Toko Tebus',
        maxredemption: 'Jumlah maksimum penarikan telah dicapai.',
        noredeemoption:
          '<p>Tidak Ada Opsi Tebus yang tersedia saat ini</p><p>Silakan coba lagi nanti atau hubungi tim dukungan kami.</p>',
      },
      pack: {
        nodata: 'Anda akan melihat paket di sini setelah mereka tersedia.',
      },
      payout: {
        form: {
          title: 'Tebus',
          placeholder: 'Masukkan alamat pembayaran Anda',
          noemail:
            'Paket ini memerlukan alamat email yang ditetapkan dalam profil Anda.',
          cta: 'Lanjutkan',
          confirmdialog: {
            title: 'Apakah Anda yakin?',
            address: 'Alamat Pembayaran:',
            amount: 'Jumlah:',
            confirm: 'Konfirmasi',
            cancel: 'Batal',
          },
        },
        status: {
          note: 'Catatan:',
          reason: 'Alasan:',
          rateus: 'Beri kami rating di Play Store',
          processing: {
            title: 'Pembayaran Sedang Diproses',
            description:
              'Pembayaran umumnya dikreditkan ke akun Anda dalam waktu 6 jam. Sampai saat itu, koin Anda aman bersama kami.',
          },
          processed: 'Pembayaran Berhasil',
          failed: 'Pembayaran Gagal',
          stillprocess: {
            title: 'Pembayaran masih dalam proses',
            description:
              'Permintaan pembayaran telah dikirim. Pengembalian dana akan dikeluarkan ke dompet dalam kasus kegagalan.',
          },
        },
        crypto: {
          download: {
            title: 'Tidak punya Alamat Lightning?',
            cta: 'Unduh ZBD di sini!',
          },
          info: {
            title: 'Bagaimana cara menemukan alamat lightning di aplikasi ZBD?',
            steps: [
              {
                title: 'Instal aplikasi ZBD dari Play Store',
                cta: 'Instal ZBD',
              },
              {
                title: 'Klik pada ikon profil menu samping',
              },
              {
                title: 'Klik pada nama pengguna',
                description:
                  'Ini akan menyalin alamat lightning ke clipboard Anda',
              },
            ],
          },
        },
      },
    },
    spin: {
      title: 'Putar & Menang',
      description:
        'Berkesempatan memenangkan tas penuh Gems untuk memutar roda keberuntungan.',
      timer: {
        wait: 'Tunggu',
        end: 'untuk mencoba keberuntungan Anda.',
      },
      cta: 'Putar',
      completeoffer: {
        cta: 'Selesaikan Satu tugas untuk membuka',
        description:
          'Anda harus menyelesaikan satu penawaran untuk membuka putaran!',
      },
      modal: {
        oops: 'Ups!',
        better: 'Semoga lebih beruntung lain kali',
        congrats: 'Selamat!',
        won: 'Anda telah menang',
      },
      again: 'Putar Lagi',
      winning: 'Hadiah Anda',
    },
    sdk: {
      play: 'Main & Dapatkan',
      survey: 'Imbalan Survei',
      spin: 'Putar & Menang',
      games: 'Permainan',
    },
    other: {
      back: 'Kembali',
    },
    empty: {
      available: 'Tidak ada data yang tersedia',
      data: 'Tidak ada data',
      found: 'Tidak ada data ditemukan',
      referrals: 'Belum ada referensi',
      contest: {
        ongoing: 'Tidak ada kontes berlangsung',
        old: 'Tidak ada kontes lama',
      },
      offers: {
        ongoing: 'Tidak ada penawaran berlangsung',
        completed: 'Tidak ada penawaran yang selesai',
        found: 'Tidak ada penawaran ditemukan',
        resetFilterCta: 'Atur Ulang Filter',
      },
      internet: 'Tidak ada koneksi internet yang aktif!',
    },
    toast: {
      refer: {
        copy: 'Kode referral disalin',
        emptycode: 'Harap masukkan kode referral',
        notExist: 'Referral tidak ada',
      },
      failed: 'Gagal berbagi, Silakan coba lagi',
      redeem: {
        maxredemption:
          'Jumlah maksimum pencairan yang diizinkan telah tercapai. Silakan coba lagi nanti.',
        pack: 'Paket ini tidak tersedia saat ini',
        validaddress: 'Harap masukkan alamat pembayaran yang valid',
        invalid: 'ID Email tidak valid',
      },
      loginfailed: 'Login Google gagal',
    },
    dialog: {
      offline: {
        title: 'Maaf, Tidak Ada Koneksi Internet',
        description:
          'Harap aktifkan WiFi atau data seluler Anda untuk mengakses penawaran yang tersedia.',
      },
      error: {
        title: 'Ada yang salah',
        description:
          'Ini bukan karena Anda, ini karena kami! <br /> Jangan khawatir, coba lagi',
        cta: 'Coba lagi',
      },
      notfound: {
        title: '404 | Halaman Tidak Ditemukan',
        description: 'Halaman yang Anda cari tidak ditemukan.',
        cta: 'Jelajahi Penawaran',
      },
      enableUsagePermission: {
        title: 'Aktifkan Akses Penggunaan',
        description:
          'Aktifkan akses penggunaan untuk mendapatkan hadiah luar biasa dari penawaran ini sekarang!',
        cta: 'Aktifkan',
      },
      confirmAlert: {
        cta: {
          confirm: 'Konfirmasi',
          cancel: 'Batal',
        },
      },
      banned: {
        heading: 'Anda dilarang menggunakan CashPlay.',
        description:
          'Jika Anda pikir ini adalah kesalahan, silakan hubungi dukungan di',
      },
      editProfile: {
        name: 'Nama',
      },
      fraud: {
        vpn: {
          title: 'Oops, Kami Mendeteksi VPN',
          desc: 'Untuk memastikan Anda memiliki pengalaman yang lancar dan aman, Anda harus mematikan VPN.',
        },
        rooted: {
          title: 'Oops, Kami Mendeteksi perangkat yang sudah di-root',
          desc: 'Untuk memastikan Anda memiliki pengalaman yang lancar dan aman, Anda harus menggunakan perangkat yang tidak di-root.',
        },
        modApp: {
          title: 'Oops, Kami Mendeteksi bahwa Anda menggunakan aplikasi mod',
          desc: 'Untuk memastikan Anda memiliki pengalaman yang lancar dan aman, Anda harus mengunduh aplikasi yang benar.',
        },
        developerOptions: {
          title: 'Oops, Kami Mendeteksi bahwa opsi pengembang diaktifkan',
          desc: 'Untuk memastikan Anda memiliki pengalaman yang lancar dan aman, Anda harus mematikan Opsi Pengembang.',
        },
        emulator: {
          title: 'Oops, Kami Mendeteksi sebuah emulator',
          desc: 'Untuk memastikan Anda memiliki pengalaman yang lancar dan aman, silakan gunakan dalam aplikasi normal.',
        },
        blacklistedApp: fraud => ({
          title: 'Peringatan! Aplikasi Mencurigakan Terdeteksi',
          desc: (
            <div>
              <p className="mb-4">
                {`Silakan uninstall aplikasi yang tercantum di bawah ini untuk menggunakan aplikasi`}
              </p>
              {fraud?.data?.map((d, index) => (
                <p key={index} className="my-1 text-color text-md ">
                  {d}
                </p>
              ))}
            </div>
          ),
        }),
        clone: {
          title: 'Oops, Kami mendeteksi bahwa perangkat Anda dikloning',
          desc: 'Untuk memastikan Anda memiliki pengalaman yang lancar dan aman, Anda harus menggunakan perangkat yang tidak dikloning.',
        },
      },
    },
    forceUpdate: {
      title: `Hai! Kami baru saja merilis pembaruan baru untuk aplikasi kami dengan fitur baru yang hebat, perbaikan, dan peningkatan bug. Silakan instal sekarang untuk pengalaman terbaik. Nikmati!`,
      cta: 'Perbarui',
    },
  },
};
